/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useRef, useEffect } from "react";
import "../index.css";
// import { GameRuleTypes } from "../types/gameRuleTypes";

// Type definitions
interface RuleDetails {
  [key: string]: unknown;
}

// interface RuleOptionsMap {
//   [key: string]: RuleOption;
// }

interface BaseComponentProps {
  ruleDetails: RuleDetails;
  updateRuleDetails: (details: RuleDetails) => void;
}

interface GenericComponentProps extends BaseComponentProps {
  ruleTargetName: string;
  bigValues: boolean;
  gamePartName: string;
  gamePartCount: number;
}

interface OverUnderComponentProps extends BaseComponentProps {
  gamePartName: string;
  gamePartCount: number;
}

// interface LineComponentProps extends BaseComponentProps {
//   gamePartName: string;
//   gamePartCount: number;
// }

interface RuleLogicComponentProps {
  ruleType: string;
  gamePartName: string;
  gamePartCount: number;
  ruleDetails: RuleDetails;
  updateRuleDetails: (details: RuleDetails) => void;
}

interface RuleLogicDisplayProps {
  ruleType: string;
  gamePartName: string;
  gamePartCount: number;
  ruleDetails: RuleDetails;
  textColor?: string;
}

interface BaseDisplayProps {
  ruleDetails: RuleDetails;
  gamePartName: string;
  gamePartCount: number;
}

const styles = {
  inputText: {
    fontSize: 16,
    color: "var(--rl-text-color, #FFF)",
    lineHeight: "30px",
    whiteSpace: "pre-wrap" as const,
  },
  numberInput: {
    border: "1px solid #ccc",
    borderRadius: 8,
    backgroundColor: "#fff",
    fontSize: 16,
    color: "#333",
    textAlign: "center" as const,
    paddingLeft: 8,
    paddingRight: 8,
  },
};

// interface OverUnderDisplayProps extends BaseDisplayProps {
//   gamePartName: string;
//   gamePartCount: number;
// }

// interface LineDisplayProps extends BaseDisplayProps {
//   gamePartName: string;
//   gamePartCount: number;
// }

// Rule options dictionary
// const ruleOptionsDict: RuleOptionsMap = {
//   "Over/Under 1": {
//     text: GameRuleTypes["Over/Under 1"],
//     defaults: { value_change: 0.5 },
//     min_level: "Basic",
//     min_period_count: 0,
//     example:
//       "Alert me when the live Over/Under changes by a specific number of points from the opening line.\n\nAn NBA game opens with an O/U of 220. If the live O/U rises to 220.5 or higher (+0.5 points), alert me.",
//     //      "When the Over/Under changes by +0.5 from the Start of the Game\n\nIn a game that opens with Over/Under at 47.5, if it moves to 48.0, you get an alert.",
//   },
//   "Over/Under 1Percent": {
//     text: GameRuleTypes["Over/Under 1Percent"],
//     defaults: { percent: 10 },
//     min_level: "Basic",
//     min_period_count: 0,
//     example:
//       "Alert me when the live Over/Under changes by a percentage of the opening line.\n\nAn NBA game opens with an O/U of 220. If the live O/U increases
//     min_period_count: 0,
//     example:
//       "Alert me when the live Over/Under reaches a specific target number.\n\nAn NBA game (pregame or live) where the O/U reaches 230 or higher, alert me.",
//     //      "If the Over/Under is >= 220.0\n\nIf the Over/Under hits this thresold (even before the game starts), you get an alert.",
//   },
//   "Over/Under 3": {
//     text: GameRuleTypes["Over/Under 3"],
//     defaults: { equality: ">=", percent: 50, period: 2 },
//     min_level: "Basic",
//     min_period_count: 0,
//     example:
//       "Alert me when the live total score crosses a percentage of the opening O/U at the start of a later period.\n\nAn NBA game opens O/U at 220. At the start of the 3rd quarter, if the combined score is already 110+ (50% of 220), alert me.",
//     //      "Alert me when the live total score crosses a percentage of the opening O/U at the start of a later period.\n\nExample: An NBA game opens O/U at 220. At the start of the 3rd quarter, if the combined score is already 110+ (50% of 220), alert me — the game is on pace to go over.",
//   },
//   "Over/Under 3Shift": {
//     text: GameRuleTypes["Over/Under 3Shift"],
//     defaults: { equality: ">=", percent: 50, period: 2 },
//     min_level: "Basic",
//     min_period_count: 0,
//     example:
//       "Alert me when the live Over/Under reaches a percentage of the opening O/U at the start of a later period.\n\nAn NBA game opens O/U at 220. At the start of the 2nd half, if the live O/U is 110+ (50% of 220), alert me.",
//     //      "Alert me when the live total score crosses a percentage of the opening O/U at the start of a later period.\n\nExample: An NBA game opens O/U at 220. At the start of the 3rd quarter, if the combined score is already 110+ (50% of 220), alert me — the game is on pace to go over.",
//   },
//   "Over/Under 3Detail": {
//     text: GameRuleTypes["Over/Under 3Detail"],
//     defaults: { equality: ">=", percent: 50, period: 2 },
//     min_level: "Pro",
//     min_period_count: 3,
//     example:
//       "Alert me when the total score at the start of selected periods reaches a percentage of the opening O/U.\n\nAn NBA game opens O/U at 200. At the start of the 2nd period, if the combined score is 100+ (50% of 200) or at the start of the 3nd period, if the combined score is 160+ (80% of 200), alert me.",
//     //      "Alert me when the live total score crosses a percentage of the opening O/U at the start of a later period.\n\nExample: An NBA game opens O/U at 220. At the start of the 3rd quarter, if the combined score is already 110+ (50% of 220), alert me — the game is on pace to go over.",
//   },
//   "Over/Under 3ShiftDetail": {
//     text: GameRuleTypes["Over/Under 3ShiftDetail"],
//     defaults: { equality: ">=", percent: 50, period: 2 },
//     min_level: "Pro",
//     min_period_count: 3,
//     example:
//       "Alert me when the live Over/Under at the start of selected periods reaches a percentage of the opening O/U.\n\nAn NBA game opens O/U at 200. At the start of the 2nd period, if the live O/U is 160+ (80% of 200) or at the start of the 3nd period, if the live O/U is 150+ (75% of 200), alert me.",
//     //      "Alert me when the live total score crosses a percentage of the opening O/U at the start of a later period.\n\nExample: An NBA game opens O/U at 220. At the start of the 3rd quarter, if the combined score is already 110+ (50% of 220), alert me — the game is on pace to go over.",
//   },
//   "Spread 1": {
//     text: GameRuleTypes["Spread 1"],
//     defaults: { value_change: 0.5 },
//     min_level: "Basic",
//     min_period_count: 0,
//     example:
//       "Alert me when the live spread changes by a specific number of points from the opening spread.\n\nA team opens as a -6.5 favorite. If the live spread moves to -7.0 or greater (+0.5 points), alert me.",
//     //      "When the Spread changes by +2.0 from the Start of the Game\n\nIn a game that opens with the Spread at +10.0, if it moves to +12.0, you get an alert.",
//   },
//   "Spread 1Percent": {
//     text: GameRuleTypes["Spread 1Percent"],
//     defaults: { percent: 10 },
//     min_level: "Basic",
//     min_period_count: 0,
//     example:
//       "Alert me when the live spread changes by a percentage from the opening spread.\n\nA team opens as a -10 spread favorite. If the live spread moves to -11 or greater (+10%), alert me.",
//     //      "When the Spread changes by +20% from the Start of the Game\n\nIn a game that opens with the Spread at +10.0, if it moves to +12.0, you get an alert.",
//   },
//   "Spread 2": {
//     text: GameRuleTypes["Spread 2"],
//     defaults: { equality: ">=", value: 10, team: "Either Team" },
//     min_level: "Basic",
//     min_period_count: 0,
//     example:
//       //      "Alert me when the live Over/Under reaches a specific target number.\n\nAn NBA game (pregame or live) where the O/U reaches 230 or higher, alert me.",
//       "Alert me when the live spread reaches a specific target number.\n\nAn NBA game (pregame or live) where Team A's is favored by -6.5 or less, alert me.",
//     //      "Alert me when the Spread reaches a target value +7.5.\n\nExample: You want to find underdogs getting 7.5 or more points. Any game where the spread is +7.5 or greater triggers an alert.",
//   },
//   "Moneyline 1": {
//     text: GameRuleTypes["Moneyline 1"],
//     defaults: {
//       value_change: 0.5,
//     },
//     min_level: "Basic",
//     min_period_count: 0,
//     example:
//       "Alert me when the live moneyline changes by a specific amount from the opening moneyline.\n\nA team opens at +120. If the live moneyline inceases to +130 (+10 points) or higher, alert me.",
//     //      "When the Moneyline changes by +200 from the Start of the Game\n\nThe team's money line goes from +150 to +350, you get an alert.",
//   },
//   "Moneyline 1Percent": {
//     text: GameRuleTypes["Moneyline 1Percent"],
//     defaults: {
//       percent: 10,
//     },
//     min_level: "Basic",
//     min_period_count: 0,
//     example:
//       "Alert me when the live moneyline changes by a percentage from the opening moneyline.\n\nA team opens at +100. If the live moneyline increases to +110 (10%) or higher, alert me.",
//     //      "When the Moneyline changes by 50% from the Start of the Game\n\nThe team's money line goes from +100 to +150, you get an alert.",
//   },
//   "Moneyline 2": {
//     text: GameRuleTypes["Moneyline 2"],
//     defaults: { equality: ">=", value: 100, team: "Either Team's" },
//     min_level: "Basic",
//     min_period_count: 0,
//     example:
//       "Alert me when either team's live moneyline reaches a target value.\n\nIf either team's live moneyline reaches +100 or higher, alert me.",
//     //      "Alert me when the Moneyline reaches a target value.\n\nExample: You want to bet underdogs at +150 or better. Any game where the moneyline hits +150 or higher triggers an alert.",
//   },
//   "Moneyline 3": {
//     text: GameRuleTypes["Moneyline 3"],
//     defaults: {
//       starting_equality: ">=",
//       starting_value: 100,
//       live_equality: "<=",
//       live_value: -100,
//     },
//     min_level: "Basic",
//     min_period_count: 0,
//     example:
//       "Alert me when a team starts at one moneyline value and reaches another live moneyline value.\n\nA team opens at +100 or higher. If its live moneyline moves to -100 or lower, alert me.",
//     //      "If the starting Moneyline is >= 100 and the live Moneyline is <= -100\n\nIf the pre-game moneylne is >= 100 and during the game the moneyline reaches <= -100, you get an alert.",
//   },
//   "Combination 1": {
//     text: GameRuleTypes["Combination 1"],
//     defaults: {
//       moneylineEquality: ">=",
//       // moneyline_number_sign: "+",
//       moneylineValue: 100,
//       // moneyline_favorite_underdog: "either",
//       // spread_favorite_underdog: "either",
//       // spread_number_sign: "+",
//       spreadEquality: ">=",
//       spreadValue: 10,
//     },
//     min_level: "Pro",
//     min_period_count: 0,
//     example:
//       "Alert me when both the moneyline and spread reach their target values.\n\nA team's live moneyline reaches +100 or higher and its live spread reaches +10 or higher, alert me.",
//     //      "Alert me when BOTH the Moneyline AND the Spread meet their targets at the same time.\n\nExample: You want games where a team is a +120 or better underdog on the moneyline AND getting +3.5 or more points on the spread — both conditions must be true.",
//   },
//   "Combination 2": {
//     text: GameRuleTypes["Combination 2"],
//     defaults: {
//       moneylineEquality: ">=",
//       // moneyline_number_sign: "+",
//       moneylineValue: 100,
//       // moneyline_favorite_underdog: "either",
//       // spread_favorite_underdog: "either",
//       // spread_number_sign: "+",
//       spreadEquality: ">=",
//       spreadValue: 10,
//     },
//     min_level: "Pro",
//     min_period_count: 0,
//     example:
//       "Alert me when either the moneyline or spread reaches its target value.\n\nA team's live moneyline reaches +100 or higher, or its live spread reaches +10 or higher, alert me.",
//     //      "Alert me when EITHER the Moneyline OR the Spread meets its target.\n\nExample: Alert me any time a team is either a +150 or better underdog on the moneyline, OR is getting 7.5 or more points — either condition alone is enough to trigger an alert.",
//   },
//   "Combination 3": {
//     text: GameRuleTypes["Combination 3"],
//     defaults: {
//       moneylineEquality: ">=",
//       // moneyline_number_sign: "+",
//       moneylineValue: 100,
//       // moneyline_favorite_underdog: "either",
//       // spread_favorite_underdog: "either",
//       // spread_number_sign: "+",
//       spreadEquality: ">=",
//       spreadValue: 10,
//     },
//     min_level: "Pro",
//     min_period_count: 0,
//     example:
//       "Alert me when a team starts with a specific spread and its live moneyline reaches a target value.\n\nA team opens with a spread of +10 or higher and its live moneyline reaches +100 or higher, alert me.",
//     //      "Alert me when EITHER the Moneyline OR the Spread meets its target.\n\nExample: Alert me any time a team is either a +150 or better underdog on the moneyline, OR is getting 7.5 or more points — either condition alone is enough to trigger an alert.",
//   },
// };

// const getLabelByValue = (
//   value: string,
//   ref_dict: Array<{ label: string; value: string }>
// ): string => {
//   for (const entry of ref_dict) {
//     if (entry.value === value) {
//       return entry.label;
//     }
//   }
//   return "";
// };

// Export function for rule options
// function RuleOptions(): RuleOptionsMap {
//   return ruleOptionsDict;
// }

// Simple Select Component (replaces PickerDialog)
interface SelectDialogProps {
  selectedValue: string;
  updateSelectedValue: (value: string) => void;
  optionData: Array<{ label: string; value: string }>;
  width?: number;
  marginTop: number;
}

const SelectDialog: React.FC<SelectDialogProps> = ({
  selectedValue,
  updateSelectedValue,
  optionData,
  marginTop = 5,
  width = 60,
}) => {
  const selectedOption = optionData.find((opt) => opt.value === selectedValue);

  return (
    <div
      style={{
        position: "relative",
        display: "inline-block",
        height: 20,
        width: width,
      }}
    >
      <select
        className="font_family_base"
        value={selectedValue}
        onChange={(e) => updateSelectedValue(e.target.value)}
        style={{
          border: "1px solid #ccc",
          borderRadius: 8,
          backgroundColor: "#fff",
          fontSize: 12,
          color: "transparent",
          padding: "0px 4px",
          width: "100%",
          height: 24,
          marginTop: marginTop,
          textAlign: "center",
          WebkitAppearance: "none",
          MozAppearance: "none",
          appearance: "none",
        }}
      >
        {optionData.map((option) => (
          <option
            key={option.value}
            value={option.value}
            style={{ color: "#333" }}
          >
            {option.label}
          </option>
        ))}
      </select>
      <div
        style={{
          position: "absolute",
          top: marginTop,
          left: 0,
          right: 0,
          height: 24,
          pointerEvents: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 16,
          color: "#333",
        }}
      >
        {selectedOption?.value}
        <span style={{ marginLeft: 4, fontSize: 10 }}>▼</span>
      </div>
    </div>
  );
};

// Simple Stepper Input Component
interface StepperInputProps {
  initialValue: number;
  min: number;
  max: number;
  step: number;
  bigStep: number;
  onValueChange: (value: number) => void;
  skipZero: boolean;
  showDecimalValue: boolean;
  showPercent: boolean;
  useBigStep: boolean;
  ordinalMap: boolean;
  showPlusSign: boolean;
  // Values strictly between -gap and +gap are skipped: stepping into that
  // range jumps to the boundary on the other side (e.g. American moneyline
  // odds go +100 → -100).
  gap?: number;
}

const StepperInput: React.FC<StepperInputProps> = ({
  initialValue,
  min,
  max,
  step,
  bigStep,
  onValueChange,
  skipZero,
  showDecimalValue,
  showPercent,
  useBigStep,
  ordinalMap,
  showPlusSign,
  gap,
}) => {
  const [value, setValue] = useState<number>(initialValue);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const valueRef = useRef<number>(value);
  const lastTouchTimeRef = useRef<number>(0);
  const ordinalValues = [
    "0th",
    "1st",
    "2nd",
    "3rd",
    "4th",
    "5th",
    "6th",
    "7th",
    "8th",
    "9th",
  ];

  // Keep valueRef in sync with value
  useEffect(() => {
    valueRef.current = value;
  }, [value]);

  const skipGap = (prev: number, next: number): number =>
    gap && Math.abs(next) < gap ? (next > prev ? gap : -gap) : next;

  const doIncrement = () => {
    let newValue = skipGap(valueRef.current, valueRef.current + step);
    if (skipZero && valueRef.current < 0 && newValue == 0) {
      newValue = step;
    }
    newValue = Math.min(max, newValue);
    valueRef.current = newValue;
    setValue(newValue);
    onValueChange(newValue);
  };

  const doDecrement = () => {
    let newValue = skipGap(valueRef.current, valueRef.current - step);
    if (skipZero && valueRef.current > 0 && newValue == 0) {
      newValue = -step;
    } else {
      newValue = Math.max(min, newValue);
    }
    valueRef.current = newValue;
    setValue(newValue);
    onValueChange(newValue);
  };

  const doBigIncrement = () => {
    let newValue = skipGap(valueRef.current, valueRef.current + bigStep);
    if (skipZero && valueRef.current < 0 && newValue == 0) {
      newValue = bigStep;
    }
    newValue = Math.min(max, newValue);
    valueRef.current = newValue;
    setValue(newValue);
    onValueChange(newValue);
  };

  const doBigDecrement = () => {
    let newValue = skipGap(valueRef.current, valueRef.current - bigStep);
    if (skipZero && valueRef.current > 0 && newValue == 0) {
      newValue = -bigStep;
    } else {
      newValue = Math.max(min, newValue);
    }
    valueRef.current = newValue;
    setValue(newValue);
    onValueChange(newValue);
  };

  const stopHold = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  const startHoldIncrement = (e: React.MouseEvent | React.TouchEvent) => {
    if (e.type === "mousedown" && Date.now() - lastTouchTimeRef.current < 500)
      return;
    if (e.type === "touchstart") lastTouchTimeRef.current = Date.now();
    if (intervalRef.current) return;
    doIncrement();
    intervalRef.current = setInterval(doIncrement, 150);
  };

  const startHoldDecrement = (e: React.MouseEvent | React.TouchEvent) => {
    if (e.type === "mousedown" && Date.now() - lastTouchTimeRef.current < 500)
      return;
    if (e.type === "touchstart") lastTouchTimeRef.current = Date.now();
    if (intervalRef.current) return;
    doDecrement();
    intervalRef.current = setInterval(doDecrement, 150);
  };

  const startHoldBigIncrement = (e: React.MouseEvent | React.TouchEvent) => {
    if (e.type === "mousedown" && Date.now() - lastTouchTimeRef.current < 500)
      return;
    if (e.type === "touchstart") lastTouchTimeRef.current = Date.now();
    if (intervalRef.current) return;
    doBigIncrement();
    intervalRef.current = setInterval(doBigIncrement, 150);
  };

  const startHoldBigDecrement = (e: React.MouseEvent | React.TouchEvent) => {
    if (e.type === "mousedown" && Date.now() - lastTouchTimeRef.current < 500)
      return;
    if (e.type === "touchstart") lastTouchTimeRef.current = Date.now();
    if (intervalRef.current) return;
    doBigDecrement();
    intervalRef.current = setInterval(doBigDecrement, 150);
  };

  useEffect(() => {
    return () => stopHold();
  }, []);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 4,
        marginTop: 5,
        paddingLeft: 5,
        paddingRight: 5,
      }}
    >
      {useBigStep && (
        <button
          onMouseDown={startHoldBigDecrement}
          onMouseUp={stopHold}
          onMouseLeave={stopHold}
          onTouchStart={startHoldBigDecrement}
          onTouchEnd={stopHold}
          onContextMenu={(e) => e.preventDefault()}
          className="font_family_base"
          style={{
            border: "none",
            background: "#FFFFFF",
            padding: 0,
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
            width: 24,
            height: 24,
          }}
        >
          <svg width="28" height="28" viewBox="0 0 24 24" fill="#000000">
            <path d="M7 7l5 5 5-5z" />
            <path d="M7 12l5 5 5-5z" />
          </svg>
        </button>
      )}
      <button
        onMouseDown={startHoldDecrement}
        onMouseUp={stopHold}
        onMouseLeave={stopHold}
        onTouchStart={startHoldDecrement}
        onTouchEnd={stopHold}
        onContextMenu={(e) => e.preventDefault()}
        className="font_family_base"
        style={{
          border: "none",
          background: "#FFFFFF",
          padding: 0,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "50%",
          width: 24,
          height: 24,
        }}
      >
        <svg width="28" height="28" viewBox="0 0 24 24" fill="#000000">
          <path d="M7 10l5 5 5-5z" />
        </svg>
      </button>
      <span
        className="font_family_base"
        style={{
          fontSize: 16,
          color: "#FFF",
          minWidth: 30,
          textAlign: "center",
        }}
      >
        {ordinalMap && value >= 0 && value < ordinalValues.length
          ? ordinalValues[value]
          : (value > 0 && showPlusSign ? "+" : "") +
            (showDecimalValue ? value.toFixed(1) : value)}
        {showPercent && "%"}
      </span>
      <button
        onMouseDown={startHoldIncrement}
        onMouseUp={stopHold}
        onMouseLeave={stopHold}
        onTouchStart={startHoldIncrement}
        onTouchEnd={stopHold}
        onContextMenu={(e) => e.preventDefault()}
        className="font_family_base"
        style={{
          border: "none",
          background: "#FFFFFF",
          padding: 0,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "50%",
          width: 24,
          height: 24,
        }}
      >
        <svg width="28" height="28" viewBox="0 0 24 24" fill="#000000">
          <path d="M7 14l5-5 5 5z" />
        </svg>
      </button>
      {useBigStep && (
        <button
          onMouseDown={startHoldBigIncrement}
          onMouseUp={stopHold}
          onMouseLeave={stopHold}
          onTouchStart={startHoldBigIncrement}
          onTouchEnd={stopHold}
          onContextMenu={(e) => e.preventDefault()}
          className="font_family_base"
          style={{
            border: "none",
            background: "#FFFFFF",
            padding: 0,
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
            width: 24,
            height: 24,
          }}
        >
          <svg width="28" height="28" viewBox="0 0 24 24" fill="#000000">
            <path d="M7 12l5-5 5 5z" />
            <path d="M7 17l5-5 5 5z" />
          </svg>
        </button>
      )}
    </div>
  );
};

// Starting amount for a Value Change stepper. With bigValues (moneyline,
// steps of 5) a saved amount is snapped to the nearest non-zero multiple of 5.
const initialValueChange = (saved: unknown, bigValues: boolean): number => {
  if (typeof saved !== "number") return bigValues ? 5 : 0.5;
  if (!bigValues) return saved;
  const snapped = Math.round(saved / 5) * 5;
  return snapped !== 0 ? snapped : saved < 0 ? -5 : 5;
};

const GenericValueChange: React.FC<GenericComponentProps> = ({
  bigValues,
  ruleTargetName,
  ruleDetails,
  updateRuleDetails,
}) => {
  const valueChangeKey = "value_change";
  const [valueChange, setValueChange] = useState<number>(() =>
    initialValueChange(ruleDetails[valueChangeKey], bigValues),
  );

  const updateDetails = (newValue: number): void => {
    const output: RuleDetails = {};
    output[valueChangeKey] = newValue;
    updateRuleDetails(output);
  };

  const handleValueChange = (value: number): void => {
    setValueChange(value);
    updateDetails(value);
  };

  useEffect(() => {
    updateDetails(valueChange);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ marginTop: 10, marginBottom: 10 }}>
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "flex-start",
            justifyContent: "center",
          }}
        >
          <span className="font_family_base" style={styles.inputText}>
            When the {ruleTargetName} changes by{" "}
          </span>
          <StepperInput
            initialValue={valueChange}
            min={-9999}
            max={9999}
            step={bigValues ? 5.0 : 0.5}
            bigStep={bigValues ? 100 : 10.0}
            onValueChange={handleValueChange}
            skipZero={true}
            showDecimalValue={!bigValues}
            showPercent={false}
            useBigStep={true}
            ordinalMap={false}
            showPlusSign={true}
          />
          <span className="font_family_base" style={styles.inputText}>
            {" "}
            from{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            the{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            Start{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            of{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            the{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            Game{" "}
          </span>
        </div>
      </div>
    </div>
  );
};

const GenericPercentChange: React.FC<GenericComponentProps> = ({
  ruleDetails,
  ruleTargetName,
  updateRuleDetails,
}) => {
  const valueChangeKey = "percent";
  const [valueChange, setValueChange] = useState<number>(
    (ruleDetails[valueChangeKey] as number) ?? 1,
  );

  const updateDetails = (newValue: number): void => {
    const output: RuleDetails = {};
    output[valueChangeKey] = newValue;
    updateRuleDetails(output);
  };

  const handleValueChange = (value: number): void => {
    setValueChange(value);
    updateDetails(value);
  };

  useEffect(() => {
    updateDetails(valueChange);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ marginTop: 10, marginBottom: 10 }}>
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "flex-start",
            justifyContent: "center",
          }}
        >
          <span className="font_family_base" style={styles.inputText}>
            When the {ruleTargetName} changes by{" "}
          </span>
          <StepperInput
            initialValue={valueChange}
            min={-100}
            max={100}
            step={1}
            bigStep={10}
            onValueChange={handleValueChange}
            skipZero={true}
            showDecimalValue={false}
            showPercent={true}
            useBigStep={true}
            ordinalMap={false}
            showPlusSign={true}
          />
          <span className="font_family_base" style={styles.inputText}>
            {" "}
            from{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            the{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            Start{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            of{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            the{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            Game{" "}
          </span>
        </div>
      </div>
    </div>
  );
};

// Lines whose "Hits Value" target can't use the default 0+ stepper.
// spread:    any value, +/- signed (favorite -3.5, underdog +3.5)
// moneyline: American odds — <= -100 or >= +100, whole numbers
export type HitsValueLineType = "spread" | "moneyline";

const hitsValueStepper = (lineType?: HitsValueLineType) => {
  if (lineType === "moneyline")
    return {
      min: -9999,
      step: 5,
      bigStep: 100,
      gap: 100,
      defaultValue: 100,
      showDecimalValue: false,
      showPlusSign: true,
    };
  if (lineType === "spread")
    return {
      min: -9999,
      step: 0.5,
      bigStep: 10.0,
      gap: undefined,
      defaultValue: 0,
      showDecimalValue: true,
      showPlusSign: true,
    };
  return {
    min: 0,
    step: 0.5,
    bigStep: 10.0,
    gap: undefined,
    defaultValue: 0,
    showDecimalValue: true,
    showPlusSign: false,
  };
};

const MONEYLINE_STEPPER = hitsValueStepper("moneyline");

const initialHitsValue = (
  saved: unknown,
  stepper: ReturnType<typeof hitsValueStepper>,
): number =>
  typeof saved === "number" &&
  saved >= stepper.min &&
  !(stepper.gap && Math.abs(saved) < stepper.gap)
    ? saved
    : stepper.defaultValue;

const GenericHitsValue: React.FC<
  GenericComponentProps & {
    // When set, the >=/<= picker is hidden and this comparison is always
    // saved instead — for rules where the other direction never makes sense
    // (e.g. Arbitrage/EV, always "at least X%").
    fixedComparison?: string;
    // Shows a trailing "%" on the value stepper, for rules whose value is a
    // percentage (e.g. Arbitrage/EV profit thresholds).
    showValuePercent?: boolean;
    // Lines whose value can be negative (see HitsValueLineType).
    lineType?: HitsValueLineType;
  }
> = ({
  ruleDetails,
  ruleTargetName,
  updateRuleDetails,
  fixedComparison,
  showValuePercent,
  lineType,
}) => {
  const comparisonKey = "equality";
  const valueKey = "value";
  const comparisons = [
    { label: "Greater Than or Equal (>=)", value: ">=" },
    { label: "Less Than or Equal (<=)", value: "<=" },
  ];
  const stepper = hitsValueStepper(lineType);
  const [comparison, setComparison] = useState<string>(
    fixedComparison ?? (ruleDetails[comparisonKey] as string) ?? ">=",
  );
  const [value, setValue] = useState<number>(() =>
    initialHitsValue(ruleDetails[valueKey], stepper),
  );

  const updateDetails = (newComparison: string, newValue: number): void => {
    const output: RuleDetails = {};
    output[comparisonKey] = fixedComparison ?? newComparison;
    output[valueKey] = newValue;
    updateRuleDetails(output);
  };

  useEffect(() => {
    updateDetails(comparison, value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ marginTop: 10, marginBottom: 10 }}>
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "flex-start",
            justifyContent: "center",
          }}
        >
          <span className="font_family_base" style={styles.inputText}>
            If the {ruleTargetName} is{" "}
          </span>
          {fixedComparison ? (
            <span className="font_family_base" style={styles.inputText}>
              {fixedComparison}{" "}
            </span>
          ) : (
            <div style={{ paddingLeft: 5, paddingRight: 5 }}>
              <SelectDialog
                selectedValue={comparison}
                updateSelectedValue={(v) => {
                  setComparison(v);
                  updateDetails(v, value);
                }}
                optionData={comparisons}
                width={60}
                marginTop={6}
              />
            </div>
          )}
          <div style={{ paddingRight: 5 }}>
            <StepperInput
              initialValue={value}
              min={stepper.min}
              max={9999}
              step={stepper.step}
              bigStep={stepper.bigStep}
              gap={stepper.gap}
              onValueChange={(v) => {
                setValue(v);
                updateDetails(comparison, v);
              }}
              skipZero={false}
              showDecimalValue={stepper.showDecimalValue}
              showPercent={showValuePercent ?? false}
              useBigStep={true}
              ordinalMap={false}
              showPlusSign={stepper.showPlusSign}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const GenericTeamValueChange: React.FC<GenericComponentProps> = ({
  bigValues,
  ruleTargetName,
  ruleDetails,
  updateRuleDetails,
}) => {
  const valueChangeKey = "value_change";
  const [valueChange, setValueChange] = useState<number>(() =>
    initialValueChange(ruleDetails[valueChangeKey], bigValues),
  );

  const updateDetails = (newValue: number): void => {
    const output: RuleDetails = {};
    output[valueChangeKey] = newValue;
    updateRuleDetails(output);
  };

  const handleValueChange = (value: number): void => {
    setValueChange(value);
    updateDetails(value);
  };

  // Save the amount if it was snapped to a multiple of 5 above.
  useEffect(() => {
    if (valueChange !== ruleDetails[valueChangeKey]) updateDetails(valueChange);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ marginTop: 10, marginBottom: 10 }}>
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "flex-start",
            justifyContent: "center",
          }}
        >
          <span className="font_family_base" style={styles.inputText}>
            When the {ruleTargetName} changes by{" "}
          </span>
          <StepperInput
            initialValue={valueChange}
            min={-9999}
            max={9999}
            step={bigValues ? 5.0 : 0.5}
            bigStep={bigValues ? 100 : 10.0}
            onValueChange={handleValueChange}
            skipZero={true}
            showDecimalValue={!bigValues}
            showPercent={false}
            useBigStep={true}
            ordinalMap={false}
            showPlusSign={true}
          />
          <span className="font_family_base" style={styles.inputText}>
            {" "}
            from{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            the{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            Start{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            of{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            the{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            Game{" "}
          </span>
        </div>
      </div>
    </div>
  );
};

const GenericTeamPercentChange: React.FC<GenericComponentProps> = ({
  ruleDetails,
  ruleTargetName,
  updateRuleDetails,
}) => {
  const valueChangeKey = "percent";
  const [valueChange, setValueChange] = useState<number>(
    (ruleDetails[valueChangeKey] as number) ?? 1,
  );

  const updateDetails = (newValue: number): void => {
    const output: RuleDetails = {};
    output["type"] = "Over/Under 1Percent";
    output[valueChangeKey] = newValue;
    updateRuleDetails(output);
  };

  const handleValueChange = (value: number): void => {
    setValueChange(value);
    updateDetails(value);
  };

  useEffect(() => {
    updateDetails(valueChange);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ marginTop: 10, marginBottom: 10 }}>
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "flex-start",
            justifyContent: "center",
          }}
        >
          <span className="font_family_base" style={styles.inputText}>
            When the {ruleTargetName} changes by{" "}
          </span>
          <StepperInput
            initialValue={valueChange}
            min={-100}
            max={100}
            step={1}
            bigStep={10}
            onValueChange={handleValueChange}
            skipZero={true}
            showDecimalValue={false}
            showPercent={true}
            useBigStep={true}
            ordinalMap={false}
            showPlusSign={true}
          />
          <span className="font_family_base" style={styles.inputText}>
            {" "}
            from{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            the{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            Start{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            of{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            the{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            Game{" "}
          </span>
        </div>
      </div>
    </div>
  );
};

const GenericTeamHitsValue: React.FC<
  GenericComponentProps & {
    // See GenericHitsValue.
    lineType?: HitsValueLineType;
  }
> = ({ ruleDetails, ruleTargetName, updateRuleDetails, lineType }) => {
  const comparisonKey = "equality";
  const valueKey = "value";
  const comparisons = [
    { label: "Greater Than or Equal (>=)", value: ">=" },
    { label: "Less Than or Equal (<=)", value: "<=" },
  ];
  const stepper = hitsValueStepper(lineType);
  const [comparison, setComparison] = useState<string>(
    (ruleDetails[comparisonKey] as string) ?? ">=",
  );
  const [value, setValue] = useState<number>(() =>
    initialHitsValue(ruleDetails[valueKey], stepper),
  );

  const updateDetails = (newComparison: string, newValue: number): void => {
    const output: RuleDetails = {};
    output["type"] = "Over/Under 2";
    output[comparisonKey] = newComparison;
    output[valueKey] = newValue;
    updateRuleDetails(output);
  };

  useEffect(() => {
    updateDetails(comparison, value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ marginTop: 10, marginBottom: 10 }}>
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "flex-start",
            justifyContent: "center",
          }}
        >
          <span className="font_family_base" style={styles.inputText}>
            If the {ruleTargetName} is{" "}
          </span>
          <div style={{ paddingLeft: 5, paddingRight: 5 }}>
            <SelectDialog
              selectedValue={comparison}
              updateSelectedValue={(v) => {
                setComparison(v);
                updateDetails(v, value);
              }}
              optionData={comparisons}
              width={60}
              marginTop={6}
            />
          </div>
          <div style={{ paddingRight: 5 }}>
            <StepperInput
              initialValue={value}
              min={stepper.min}
              max={9999}
              step={stepper.step}
              bigStep={stepper.bigStep}
              gap={stepper.gap}
              onValueChange={(v) => {
                setValue(v);
                updateDetails(comparison, v);
              }}
              skipZero={false}
              showDecimalValue={stepper.showDecimalValue}
              showPercent={false}
              useBigStep={true}
              ordinalMap={false}
              showPlusSign={stepper.showPlusSign}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

// Over/Under Component
// const Rule1Component_OverUnderValueChange: React.FC<
//   OverUnderComponentProps
// > = ({ ruleDetails, updateRuleDetails }) => {
//   const valueChangeKey = "value_change";
//   const [valueChange, setValueChange] = useState<number>(
//     ruleDetails[valueChangeKey] as number,
//   );

//   const updateDetails = (newValue: number): void => {
//     const output: RuleDetails = {};
//     output["type"] = "Over/Under 1";
//     output[valueChangeKey] = newValue;
//     updateRuleDetails(output);
//   };

//   const handleValueChange = (value: number): void => {
//     setValueChange(value);
//     updateDetails(value);
//   };

//   return (
//     <div style={{ marginTop: 10, marginBottom: 10 }}>
//       <div>
//         <div
//           style={{
//             display: "flex",
//             flexDirection: "row",
//             flexWrap: "wrap",
//             alignItems: "flex-start",
//             justifyContent: "center",
//           }}
//         >
//           <span className="font_family_base" style={styles.inputText}>
//             When the Over/Under changes by{" "}
//           </span>
//           <StepperInput
//             initialValue={valueChange}
//             min={-9999}
//             max={9999}
//             step={0.5}
//             bigStep={10.0}
//             onValueChange={handleValueChange}
//             skipZero={true}
//             showDecimalValue={true}
//             showPercent={false}
//             useBigStep={true}
//             ordinalMap={false}
//             showPlusSign={true}
//           />
//           <span className="font_family_base" style={styles.inputText}>
//             {" "}
//             from{" "}
//           </span>
//           <span className="font_family_base" style={styles.inputText}>
//             the{" "}
//           </span>
//           <span className="font_family_base" style={styles.inputText}>
//             Start{" "}
//           </span>
//           <span className="font_family_base" style={styles.inputText}>
//             of{" "}
//           </span>
//           <span className="font_family_base" style={styles.inputText}>
//             the{" "}
//           </span>
//           <span className="font_family_base" style={styles.inputText}>
//             Game{" "}
//           </span>
//         </div>
//       </div>
//     </div>
//   );
// };

const Rule2Component_OverUnderPercentChange: React.FC<
  OverUnderComponentProps
> = ({ ruleDetails, updateRuleDetails }) => {
  const valueChangeKey = "percent";
  const [valueChange, setValueChange] = useState<number>(
    ruleDetails[valueChangeKey] as number,
  );

  const updateDetails = (newValue: number): void => {
    const output: RuleDetails = {};
    output["type"] = "Over/Under 1Percent";
    output[valueChangeKey] = newValue;
    updateRuleDetails(output);
  };

  const handleValueChange = (value: number): void => {
    setValueChange(value);
    updateDetails(value);
  };

  return (
    <div style={{ marginTop: 10, marginBottom: 10 }}>
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "flex-start",
            justifyContent: "center",
          }}
        >
          <span className="font_family_base" style={styles.inputText}>
            When the Over/Under changes by{" "}
          </span>
          <StepperInput
            initialValue={valueChange}
            min={-100}
            max={100}
            step={1}
            bigStep={10}
            onValueChange={handleValueChange}
            skipZero={true}
            showDecimalValue={false}
            showPercent={true}
            useBigStep={true}
            ordinalMap={false}
            showPlusSign={true}
          />
          <span className="font_family_base" style={styles.inputText}>
            {" "}
            from{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            the{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            Start{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            of{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            the{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            Game{" "}
          </span>
        </div>
      </div>
    </div>
  );
};

const Rule3Component_OverUnderHitsValue: React.FC<OverUnderComponentProps> = ({
  ruleDetails,
  updateRuleDetails,
}) => {
  const comparisonKey = "equality";
  const valueKey = "value";
  const comparisons = [
    { label: "Greater Than or Equal (>=)", value: ">=" },
    { label: "Less Than or Equal (<=)", value: "<=" },
  ];
  const [comparison, setComparison] = useState<string>(
    ruleDetails[comparisonKey] as string,
  );
  const [value, setValue] = useState<number>(ruleDetails[valueKey] as number);

  const updateDetails = (newComparison: string, newValue: number): void => {
    const output: RuleDetails = {};
    output["type"] = "Over/Under 2";
    output[comparisonKey] = newComparison;
    output[valueKey] = newValue;
    updateRuleDetails(output);
  };

  return (
    <div style={{ marginTop: 10, marginBottom: 10 }}>
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "flex-start",
            justifyContent: "center",
          }}
        >
          <span className="font_family_base" style={styles.inputText}>
            If the Over/Under is{" "}
          </span>
          <div style={{ paddingLeft: 5, paddingRight: 5 }}>
            <SelectDialog
              selectedValue={comparison}
              updateSelectedValue={(v) => {
                setComparison(v);
                updateDetails(v, value);
              }}
              optionData={comparisons}
              width={60}
              marginTop={6}
            />
          </div>
          <div style={{ paddingRight: 5 }}>
            <StepperInput
              initialValue={value}
              min={0}
              max={9999}
              step={0.5}
              bigStep={10.0}
              onValueChange={(v) => {
                setValue(v);
                updateDetails(comparison, v);
              }}
              skipZero={false}
              showDecimalValue={true}
              showPercent={false}
              useBigStep={true}
              ordinalMap={false}
              showPlusSign={false}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const Rule4Component_TotalOverUnderPercentOfInitial: React.FC<
  OverUnderComponentProps
> = ({ ruleDetails, updateRuleDetails, gamePartCount, gamePartName }) => {
  const comparisonKey = "equality";
  const percentKey = "percent";
  const periodKey = "period";
  const comparisons = [
    { label: "Greater Than or Equal (>=)", value: ">=" },
    { label: "Less Than or Equal (<=)", value: "<=" },
  ];
  const [comparison, setComparison] = useState<string>(
    ruleDetails[comparisonKey] as string,
  );
  const [percent, setPercent] = useState<number>(
    ruleDetails[percentKey] as number,
  );
  const [period, setPeriod] = useState<number>(
    ruleDetails[periodKey] as number,
  );

  const updateDetails = (c: string, p: number, pd: number): void => {
    const output: RuleDetails = {};
    output["type"] = "Over/Under 3";
    output[comparisonKey] = c;
    output[percentKey] = p;
    output[periodKey] = pd;
    updateRuleDetails(output);
  };

  return (
    <div style={{ marginTop: 10, marginBottom: 10 }}>
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "flex-start",
            justifyContent: "center",
          }}
        >
          <span className="font_family_base" style={styles.inputText}>
            At the Start of the
          </span>
          <div style={{ paddingRight: 5 }}>
            <StepperInput
              initialValue={period}
              min={2}
              max={gamePartCount}
              step={1}
              bigStep={10.0}
              onValueChange={(v) => {
                setPeriod(v);
                updateDetails(comparison, percent, v);
              }}
              skipZero={false}
              showDecimalValue={false}
              showPercent={false}
              useBigStep={false}
              ordinalMap={true}
              showPlusSign={false}
            />
          </div>
          <span className="font_family_base" style={styles.inputText}>
            {gamePartName},{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            the Total Score is{" "}
          </span>
          <div style={{ paddingLeft: 5, paddingRight: 5 }}>
            <SelectDialog
              selectedValue={comparison}
              updateSelectedValue={(v) => {
                setComparison(v);
                updateDetails(v, percent, period);
              }}
              optionData={comparisons}
              width={60}
              marginTop={5}
            />
          </div>
          <div style={{ paddingRight: 5 }}>
            <StepperInput
              initialValue={percent}
              min={0}
              max={100}
              step={0.5}
              bigStep={10.0}
              onValueChange={(v) => {
                setPercent(v);
                updateDetails(comparison, v, period);
              }}
              skipZero={false}
              showDecimalValue={true}
              showPercent={true}
              useBigStep={true}
              ordinalMap={false}
              showPlusSign={false}
            />
          </div>
          <span className="font_family_base" style={styles.inputText}>
            of{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            Over/Under{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            at{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            the{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            Start{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            of{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            the{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            Game{" "}
          </span>
        </div>
      </div>
    </div>
  );
};

const Rule5Component_OverUnderPercentOfInitial: React.FC<
  OverUnderComponentProps
> = ({ ruleDetails, updateRuleDetails, gamePartCount, gamePartName }) => {
  const comparisonKey = "equality";
  const percentKey = "percent";
  const periodKey = "period";
  const comparisons = [
    { label: "Greater Than or Equal (>=)", value: ">=" },
    { label: "Less Than or Equal (<=)", value: "<=" },
  ];
  const [comparison, setComparison] = useState<string>(
    ruleDetails[comparisonKey] as string,
  );
  const [percent, setPercent] = useState<number>(
    ruleDetails[percentKey] as number,
  );
  const [period, setPeriod] = useState<number>(
    ruleDetails[periodKey] as number,
  );

  const updateDetails = (c: string, p: number, pd: number): void => {
    const output: RuleDetails = {};
    output["type"] = "Over/Under 3Shift";
    output[comparisonKey] = c;
    output[percentKey] = p;
    output[periodKey] = pd;
    updateRuleDetails(output);
  };

  return (
    <div style={{ marginTop: 10, marginBottom: 10 }}>
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "flex-start",
            justifyContent: "center",
          }}
        >
          <span className="font_family_base" style={styles.inputText}>
            At the Start of the
          </span>
          <div style={{ paddingRight: 5 }}>
            <StepperInput
              initialValue={period}
              min={2}
              max={gamePartCount}
              step={1}
              bigStep={10.0}
              onValueChange={(v) => {
                setPeriod(v);
                updateDetails(comparison, percent, v);
              }}
              skipZero={false}
              showDecimalValue={false}
              showPercent={false}
              useBigStep={false}
              ordinalMap={true}
              showPlusSign={false}
            />
          </div>
          <span className="font_family_base" style={styles.inputText}>
            {gamePartName},{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            the Over/Under is{" "}
          </span>
          <div style={{ paddingLeft: 5, paddingRight: 5 }}>
            <SelectDialog
              selectedValue={comparison}
              updateSelectedValue={(v) => {
                setComparison(v);
                updateDetails(v, percent, period);
              }}
              optionData={comparisons}
              width={60}
              marginTop={5}
            />
          </div>
          <div style={{ paddingRight: 5 }}>
            <StepperInput
              initialValue={percent}
              min={0}
              max={500}
              step={0.5}
              bigStep={10}
              onValueChange={(v) => {
                setPercent(v);
                updateDetails(comparison, v, period);
              }}
              skipZero={false}
              showDecimalValue={true}
              showPercent={true}
              useBigStep={true}
              ordinalMap={false}
              showPlusSign={false}
            />
          </div>
          <span className="font_family_base" style={styles.inputText}>
            of{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            Over/Under{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            at{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            the{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            Start{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            of{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            Game{" "}
          </span>
        </div>
      </div>
    </div>
  );
};

const Rule6Component_TotalOverUnderPercentOfInitialMultiSelect: React.FC<
  OverUnderComponentProps
> = ({ ruleDetails, updateRuleDetails, gamePartCount, gamePartName }) => {
  const comparisons = [
    { label: "Greater Than or Equal (>=)", value: ">=" },
    { label: "Less Than or Equal (<=)", value: "<=" },
  ];

  const ordinalNames = [
    "0th",
    "1st",
    "2nd",
    "3rd",
    "4th",
    "5th",
    "6th",
    "7th",
    "8th",
    "9th",
    "10th",
    "11th",
    "12th",
  ];

  type PeriodConfig = { equality: string; percent: number; enabled: boolean };

  const initPeriods = (): Record<string, PeriodConfig> => {
    const saved = ruleDetails["periods"] as
      | Record<string, PeriodConfig>
      | undefined;
    const result: Record<string, PeriodConfig> = {};
    for (let p = 2; p <= gamePartCount; p++) {
      const key = String(p);
      result[key] = saved?.[key] ?? {
        equality: ">=",
        percent: 50,
        enabled: true,
      };
    }
    return result;
  };

  const [periods, setPeriods] =
    useState<Record<string, PeriodConfig>>(initPeriods);

  const updatePeriod = (period: number, patch: Partial<PeriodConfig>): void => {
    const updated = {
      ...periods,
      [String(period)]: { ...periods[String(period)], ...patch },
    };
    setPeriods(updated);
    updateRuleDetails({ type: "Over/Under 3Detail", periods: updated });
  };

  return (
    <div style={{ marginTop: 10, marginBottom: 10 }}>
      {Array.from({ length: gamePartCount - 1 }, (_, i) => i + 2).map(
        (period) => {
          const cfg = periods[String(period)] ?? {
            equality: ">=",
            percent: 50,
            enabled: true,
          };
          return (
            <div
              key={period}
              style={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: 8,
                opacity: cfg.enabled ? 1 : 0.35,
              }}
            >
              {/* Toggle */}
              <button
                onClick={() => updatePeriod(period, { enabled: !cfg.enabled })}
                style={{
                  width: 36,
                  height: 20,
                  borderRadius: 10,
                  border: "none",
                  backgroundColor: cfg.enabled ? "#2563eb" : "#555",
                  cursor: "pointer",
                  position: "relative",
                  flexShrink: 0,
                  marginRight: 8,
                  transition: "background-color 0.2s",
                }}
              >
                <span
                  style={{
                    position: "absolute",
                    top: 2,
                    left: cfg.enabled ? 18 : 2,
                    width: 16,
                    height: 16,
                    borderRadius: "50%",
                    backgroundColor: "#fff",
                    transition: "left 0.2s",
                  }}
                />
              </button>

              <span className="font_family_base" style={styles.inputText}>
                At the Start of the{" "}
              </span>
              <span
                className="font_family_base"
                style={{ ...styles.inputText, marginRight: 4 }}
              >
                {ordinalNames[period] ?? `${period}th`} {gamePartName},
              </span>
              <span className="font_family_base" style={styles.inputText}>
                the Total Score is{" "}
              </span>

              <div
                style={{
                  paddingLeft: 5,
                  paddingRight: 5,
                  pointerEvents: cfg.enabled ? "auto" : "none",
                }}
              >
                <SelectDialog
                  selectedValue={cfg.equality}
                  updateSelectedValue={(v) =>
                    updatePeriod(period, { equality: v })
                  }
                  optionData={comparisons}
                  width={60}
                  marginTop={5}
                />
              </div>
              <div
                style={{
                  paddingRight: 5,
                  pointerEvents: cfg.enabled ? "auto" : "none",
                }}
              >
                <StepperInput
                  key={`${period}-${cfg.percent}`}
                  initialValue={cfg.percent}
                  min={0}
                  max={200}
                  step={0.5}
                  bigStep={10.0}
                  onValueChange={(v) => updatePeriod(period, { percent: v })}
                  skipZero={false}
                  showDecimalValue={true}
                  showPercent={true}
                  useBigStep={true}
                  ordinalMap={false}
                  showPlusSign={false}
                />
              </div>
              <span className="font_family_base" style={styles.inputText}>
                of O/U at Start of the Game
              </span>
            </div>
          );
        },
      )}
    </div>
  );
};

const Rule7Component_OverUnderPercentOfInitialMultiSelect: React.FC<
  OverUnderComponentProps
> = ({ ruleDetails, updateRuleDetails, gamePartCount, gamePartName }) => {
  const comparisons = [
    { label: "Greater Than or Equal (>=)", value: ">=" },
    { label: "Less Than or Equal (<=)", value: "<=" },
  ];

  const ordinalNames = [
    "0th",
    "1st",
    "2nd",
    "3rd",
    "4th",
    "5th",
    "6th",
    "7th",
    "8th",
    "9th",
    "10th",
    "11th",
    "12th",
  ];

  type PeriodConfig = { equality: string; percent: number; enabled: boolean };

  const initPeriods = (): Record<string, PeriodConfig> => {
    const saved = ruleDetails["periods"] as
      | Record<string, PeriodConfig>
      | undefined;
    const result: Record<string, PeriodConfig> = {};
    for (let p = 2; p <= gamePartCount; p++) {
      const key = String(p);
      result[key] = saved?.[key] ?? {
        equality: ">=",
        percent: 50,
        enabled: true,
      };
    }
    return result;
  };

  const [periods, setPeriods] =
    useState<Record<string, PeriodConfig>>(initPeriods);

  const updatePeriod = (period: number, patch: Partial<PeriodConfig>): void => {
    const updated = {
      ...periods,
      [String(period)]: { ...periods[String(period)], ...patch },
    };
    setPeriods(updated);
    updateRuleDetails({ type: "Over/Under 3ShiftDetail", periods: updated });
  };

  return (
    <div style={{ marginTop: 10, marginBottom: 10 }}>
      {Array.from({ length: gamePartCount - 1 }, (_, i) => i + 2).map(
        (period) => {
          const cfg = periods[String(period)] ?? {
            equality: ">=",
            percent: 50,
            enabled: true,
          };
          return (
            <div
              key={period}
              style={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: 8,
                opacity: cfg.enabled ? 1 : 0.35,
              }}
            >
              {/* Toggle */}
              <button
                onClick={() => updatePeriod(period, { enabled: !cfg.enabled })}
                style={{
                  width: 36,
                  height: 20,
                  borderRadius: 10,
                  border: "none",
                  backgroundColor: cfg.enabled ? "#2563eb" : "#555",
                  cursor: "pointer",
                  position: "relative",
                  flexShrink: 0,
                  marginRight: 8,
                  transition: "background-color 0.2s",
                }}
              >
                <span
                  style={{
                    position: "absolute",
                    top: 2,
                    left: cfg.enabled ? 18 : 2,
                    width: 16,
                    height: 16,
                    borderRadius: "50%",
                    backgroundColor: "#fff",
                    transition: "left 0.2s",
                  }}
                />
              </button>

              <span className="font_family_base" style={styles.inputText}>
                At the Start of the{" "}
              </span>
              <span
                className="font_family_base"
                style={{ ...styles.inputText, marginRight: 4 }}
              >
                {ordinalNames[period] ?? `${period}th`} {gamePartName},
              </span>
              <span className="font_family_base" style={styles.inputText}>
                the Over/Under is{" "}
              </span>

              <div
                style={{
                  paddingLeft: 5,
                  paddingRight: 5,
                  pointerEvents: cfg.enabled ? "auto" : "none",
                }}
              >
                <SelectDialog
                  selectedValue={cfg.equality}
                  updateSelectedValue={(v) =>
                    updatePeriod(period, { equality: v })
                  }
                  optionData={comparisons}
                  width={60}
                  marginTop={5}
                />
              </div>
              <div
                style={{
                  paddingRight: 5,
                  pointerEvents: cfg.enabled ? "auto" : "none",
                }}
              >
                <StepperInput
                  key={`${period}-${cfg.percent}`}
                  initialValue={cfg.percent}
                  min={0}
                  max={500}
                  step={0.5}
                  bigStep={10.0}
                  onValueChange={(v) => updatePeriod(period, { percent: v })}
                  skipZero={false}
                  showDecimalValue={true}
                  showPercent={true}
                  useBigStep={true}
                  ordinalMap={false}
                  showPlusSign={false}
                />
              </div>
              <span className="font_family_base" style={styles.inputText}>
                of O/U at Start of the Game
              </span>
            </div>
          );
        },
      )}
    </div>
  );
};

const Rule9Component_ValueChange: React.FC<OverUnderComponentProps> = ({
  ruleDetails,
  updateRuleDetails,
}) => {
  const valueChangeKey = "value_change";
  const [valueChange, setValueChange] = useState<number>(
    ruleDetails[valueChangeKey] as number,
  );

  const updateDetails = (newValue: number): void => {
    const output: RuleDetails = {};
    output["type"] = "Spread 1";
    output[valueChangeKey] = newValue;
    updateRuleDetails(output);
  };

  return (
    <div style={{ marginTop: 10, marginBottom: 10 }}>
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "flex-start",
            justifyContent: "center",
          }}
        >
          <span className="font_family_base" style={styles.inputText}>
            When the Spread changes by{" "}
          </span>
          <StepperInput
            initialValue={valueChange}
            min={-9999}
            max={9999}
            step={0.5}
            bigStep={10.0}
            onValueChange={(v) => {
              setValueChange(v);
              updateDetails(v);
            }}
            skipZero={true}
            showDecimalValue={true}
            showPercent={false}
            useBigStep={true}
            ordinalMap={false}
            showPlusSign={true}
          />
          <span className="font_family_base" style={styles.inputText}>
            {" "}
            from{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            the{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            Start{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            of{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            the{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            Game{" "}
          </span>
        </div>
      </div>
    </div>
  );
};

const Rule10Component_SpreadPercentChange: React.FC<
  OverUnderComponentProps
> = ({ ruleDetails, updateRuleDetails }) => {
  const valueChangeKey = "percent";
  const [valueChange, setValueChange] = useState<number>(
    ruleDetails[valueChangeKey] as number,
  );

  const updateDetails = (newValue: number): void => {
    const output: RuleDetails = {};
    output["type"] = "Spread 1Percent";
    output[valueChangeKey] = newValue;
    updateRuleDetails(output);
  };

  return (
    <div style={{ marginTop: 10, marginBottom: 10 }}>
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "flex-start",
            justifyContent: "center",
          }}
        >
          <span className="font_family_base" style={styles.inputText}>
            When the Spread changes by{" "}
          </span>
          <StepperInput
            initialValue={valueChange}
            min={-100}
            max={100}
            step={1}
            bigStep={10}
            onValueChange={(v) => {
              setValueChange(v);
              updateDetails(v);
            }}
            skipZero={true}
            showDecimalValue={true}
            showPercent={true}
            useBigStep={true}
            ordinalMap={false}
            showPlusSign={true}
          />
          <span className="font_family_base" style={styles.inputText}>
            {" "}
            from{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            the{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            Start{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            of{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            the{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            Game{" "}
          </span>
        </div>
      </div>
    </div>
  );
};

const Rule11Component_SpreadHitsValue: React.FC<OverUnderComponentProps> = ({
  ruleDetails,
  updateRuleDetails,
}) => {
  const comparisonKey = "equality";
  const valueKey = "value";
  const teamKey = "team";
  const comparisons = [
    { label: "Greater Than or Equal (>=)", value: ">=" },
    { label: "Less Than or Equal (<=)", value: "<=" },
  ];
  const teamOptions = [
    { label: "the Home Team", value: "the Home Team" },
    { label: "the Away Team", value: "the Away Team" },
    { label: "Either Team", value: "Either Team" },
  ];
  const [comparison, setComparison] = useState<string>(
    ruleDetails[comparisonKey] as string,
  );
  const [team, setTeam] = useState<string>(ruleDetails[teamKey] as string);
  const [value, setValue] = useState<number>(ruleDetails[valueKey] as number);

  const updateDetails = (
    newTeam: string,
    newComparison: string,
    newValue: number,
  ): void => {
    const output: RuleDetails = {};
    output["type"] = "Spread 2";
    output[teamKey] = newTeam;
    output[comparisonKey] = newComparison;
    output[valueKey] = newValue;
    updateRuleDetails(output);
  };

  return (
    <div style={{ marginTop: 10, marginBottom: 10 }}>
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "flex-start",
            justifyContent: "center",
          }}
        >
          <span className="font_family_base" style={styles.inputText}>
            If the Spread for
          </span>
          <div style={{ paddingLeft: 5, paddingRight: 5 }}>
            <SelectDialog
              selectedValue={team}
              updateSelectedValue={(v) => {
                setTeam(v);
                updateDetails(v, comparison, value);
              }}
              optionData={teamOptions}
              width={140}
              marginTop={6}
            />
          </div>
          <span className="font_family_base" style={styles.inputText}>
            is{" "}
          </span>
          <div style={{ paddingLeft: 5, paddingRight: 5 }}>
            <SelectDialog
              selectedValue={comparison}
              updateSelectedValue={(v) => {
                setComparison(v);
                updateDetails(team, v, value);
              }}
              optionData={comparisons}
              width={60}
              marginTop={6}
            />
          </div>
          <div style={{ paddingRight: 5 }}>
            <StepperInput
              initialValue={value}
              min={-9999}
              max={9999}
              step={0.5}
              bigStep={10.0}
              onValueChange={(v) => {
                setValue(v);
                updateDetails(team, comparison, v);
              }}
              skipZero={false}
              showDecimalValue={true}
              showPercent={false}
              useBigStep={true}
              ordinalMap={false}
              showPlusSign={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const Rule12Component_MoneylineValueChange: React.FC<
  OverUnderComponentProps
> = ({ ruleDetails, updateRuleDetails }) => {
  const valueChangeKey = "value_change";
  const [valueChange, setValueChange] = useState<number>(
    ruleDetails[valueChangeKey] as number,
  );

  const updateDetails = (newValue: number): void => {
    const output: RuleDetails = {};
    output["type"] = "Moneyline 1";
    output[valueChangeKey] = newValue;
    updateRuleDetails(output);
  };

  return (
    <div style={{ marginTop: 10, marginBottom: 10 }}>
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "flex-start",
            justifyContent: "center",
          }}
        >
          <span className="font_family_base" style={styles.inputText}>
            When the Moneyline changes by{" "}
          </span>
          <StepperInput
            initialValue={valueChange}
            min={-9999}
            max={9999}
            step={5.0}
            bigStep={100.0}
            onValueChange={(v) => {
              setValueChange(v);
              updateDetails(v);
            }}
            skipZero={true}
            showDecimalValue={false}
            showPercent={false}
            useBigStep={true}
            ordinalMap={false}
            showPlusSign={true}
          />
          <span className="font_family_base" style={styles.inputText}>
            {" "}
            from{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            the{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            Start{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            of{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            the{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            Game{" "}
          </span>
        </div>
      </div>
    </div>
  );
};

const Rule13Component_1MoneylinePercentChange: React.FC<
  OverUnderComponentProps
> = ({ ruleDetails, updateRuleDetails }) => {
  const valueChangeKey = "percent";
  const [valueChange, setValueChange] = useState<number>(
    ruleDetails[valueChangeKey] as number,
  );

  const updateDetails = (newValue: number): void => {
    const output: RuleDetails = {};
    output["type"] = "Moneyline 1Percent";
    output[valueChangeKey] = newValue;
    updateRuleDetails(output);
  };

  return (
    <div style={{ marginTop: 10, marginBottom: 10 }}>
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "flex-start",
            justifyContent: "center",
          }}
        >
          <span className="font_family_base" style={styles.inputText}>
            When the Moneyline changes by{" "}
          </span>
          <StepperInput
            initialValue={valueChange}
            min={-999}
            max={999}
            step={5}
            bigStep={100}
            onValueChange={(v) => {
              setValueChange(v);
              updateDetails(v);
            }}
            skipZero={true}
            showDecimalValue={false}
            showPercent={true}
            useBigStep={true}
            ordinalMap={false}
            showPlusSign={true}
          />
          <span className="font_family_base" style={styles.inputText}>
            {" "}
            from{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            the{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            Start{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            of{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            the{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            Game{" "}
          </span>
        </div>
      </div>
    </div>
  );
};

const Rule14Component_MoneylineHitsValue: React.FC<OverUnderComponentProps> = ({
  ruleDetails,
  updateRuleDetails,
}) => {
  const comparisonKey = "equality";
  const valueKey = "value";
  const teamKey = "team";
  const comparisons = [
    { label: "Greater Than or Equal (>=)", value: ">=" },
    { label: "Less Than or Equal (<=)", value: "<=" },
  ];
  const teamOptions = [
    { label: "the Underdog's", value: "the Underdog's" },
    { label: "the Favorite's", value: "the Favorite's" },
    { label: "Either Team's", value: "Either Team's" },
  ];
  const [comparison, setComparison] = useState<string>(
    ruleDetails[comparisonKey] as string,
  );
  const [value, setValue] = useState<number>(ruleDetails[valueKey] as number);
  const [team, setTeam] = useState<string>(ruleDetails[teamKey] as string);

  const updateDetails = (
    newComparison: string,
    newValue: number,
    newTeam: string,
  ): void => {
    const output: RuleDetails = {};
    output["type"] = "Moneyline 2";
    output[comparisonKey] = newComparison;
    output[valueKey] = newValue;
    output[teamKey] = newTeam;
    updateRuleDetails(output);
  };

  return (
    <div style={{ marginTop: 10, marginBottom: 10 }}>
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "flex-start",
            justifyContent: "center",
          }}
        >
          <span className="font_family_base" style={styles.inputText}>
            If{" "}
          </span>
          <div style={{ paddingLeft: 5, paddingRight: 5 }}>
            <SelectDialog
              selectedValue={team}
              updateSelectedValue={(v) => {
                setTeam(v);
                updateDetails(comparison, value, v);
              }}
              optionData={teamOptions}
              width={150}
              marginTop={6}
            />
          </div>
          <span className="font_family_base" style={styles.inputText}>
            {" "}
            Moneyline is{" "}
          </span>
          <div style={{ paddingLeft: 5, paddingRight: 5 }}>
            <SelectDialog
              selectedValue={comparison}
              updateSelectedValue={(v) => {
                setComparison(v);
                updateDetails(v, value, team);
              }}
              optionData={comparisons}
              width={60}
              marginTop={6}
            />
          </div>
          <div style={{ paddingRight: 5 }}>
            <StepperInput
              initialValue={value}
              min={-9999}
              max={9999}
              step={5}
              bigStep={100}
              onValueChange={(v) => {
                setValue(v);
                updateDetails(comparison, v, team);
              }}
              skipZero={false}
              showDecimalValue={false}
              showPercent={false}
              useBigStep={true}
              ordinalMap={false}
              showPlusSign={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const Rule15Component_MoneylineStartingAndLiveValues: React.FC<
  OverUnderComponentProps
> = ({ ruleDetails, updateRuleDetails }) => {
  const startingComparisonKey = "starting_equality";
  const startingValueKey = "starting_value";
  const liveComparisonKey = "live_equality";
  const liveValueKey = "live_value";
  const comparisons = [
    { label: "Greater Than or Equal (>=)", value: ">=" },
    { label: "Less Than or Equal (<=)", value: "<=" },
  ];
  const stepper = hitsValueStepper("moneyline");
  const [startingComparison, setStartingComparison] = useState<string>(
    (ruleDetails[startingComparisonKey] as string) ?? ">=",
  );
  const [startingValue, setStartingValue] = useState<number>(() =>
    initialHitsValue(ruleDetails[startingValueKey], stepper),
  );
  const [liveComparison, setLiveComparison] = useState<string>(
    (ruleDetails[liveComparisonKey] as string) ?? ">=",
  );
  const [liveValue, setLiveValue] = useState<number>(() =>
    initialHitsValue(ruleDetails[liveValueKey], stepper),
  );

  const updateDetails = (
    newStartingComparison: string,
    newStartingValue: number,
    newLiveComparison: string,
    newLiveValue: number,
  ): void => {
    const output: RuleDetails = {};
    // output["type"] = "Moneyline 3";
    output[startingComparisonKey] = newStartingComparison;
    output[startingValueKey] = newStartingValue;
    output[liveComparisonKey] = newLiveComparison;
    output[liveValueKey] = newLiveValue;
    updateRuleDetails(output);
  };

  // Save any values that were corrected out of the -100..+100 gap above.
  useEffect(() => {
    updateDetails(startingComparison, startingValue, liveComparison, liveValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ marginTop: 10, marginBottom: 10 }}>
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "flex-start",
            justifyContent: "center",
          }}
        >
          <span className="font_family_base" style={styles.inputText}>
            If the starting Moneyline is{" "}
          </span>
          <div style={{ paddingLeft: 5, paddingRight: 5 }}>
            <SelectDialog
              selectedValue={startingComparison}
              updateSelectedValue={(v) => {
                setStartingComparison(v);
                updateDetails(v, startingValue, liveComparison, liveValue);
              }}
              optionData={comparisons}
              width={60}
              marginTop={6}
            />
          </div>
          <div style={{ paddingRight: 5 }}>
            <StepperInput
              initialValue={startingValue}
              min={stepper.min}
              max={9999}
              step={stepper.step}
              bigStep={stepper.bigStep}
              gap={stepper.gap}
              onValueChange={(v) => {
                setStartingValue(v);
                updateDetails(startingComparison, v, liveComparison, liveValue);
              }}
              skipZero={false}
              showDecimalValue={false}
              showPercent={false}
              useBigStep={true}
              ordinalMap={false}
              showPlusSign={true}
            />
          </div>
          <span className="font_family_base" style={styles.inputText}>
            and{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            the{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            live{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            Moneyline{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            is{" "}
          </span>
          <div style={{ paddingLeft: 5, paddingRight: 5 }}>
            <SelectDialog
              selectedValue={liveComparison}
              updateSelectedValue={(v) => {
                setLiveComparison(v);
                updateDetails(startingComparison, startingValue, v, liveValue);
              }}
              optionData={comparisons}
              width={60}
              marginTop={6}
            />
          </div>
          <div style={{ paddingRight: 5 }}>
            <StepperInput
              initialValue={liveValue}
              min={stepper.min}
              max={9999}
              step={stepper.step}
              bigStep={stepper.bigStep}
              gap={stepper.gap}
              onValueChange={(v) => {
                setLiveValue(v);
                updateDetails(
                  startingComparison,
                  startingValue,
                  liveComparison,
                  v,
                );
              }}
              skipZero={false}
              showDecimalValue={false}
              showPercent={false}
              useBigStep={true}
              ordinalMap={false}
              showPlusSign={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const Rule16Component_CombinationMoneylineAndSpreadValues: React.FC<
  OverUnderComponentProps
> = ({ ruleDetails, updateRuleDetails }) => {
  const comparisons = [
    { label: "Greater Than or Equal (>=)", value: ">=" },
    { label: "Less Than or Equal (<=)", value: "<=" },
  ];
  const [moneylineComparison, setMoneylineComparison] = useState<string>(
    ruleDetails["moneylineEquality"] as string,
  );
  const [moneylineValue, setMoneylineValue] = useState<number>(() =>
    initialHitsValue(ruleDetails["moneylineValue"], MONEYLINE_STEPPER),
  );
  const [spreadComparison, setSpreadComparison] = useState<string>(
    ruleDetails["spreadEquality"] as string,
  );
  const [spreadValue, setSpreadValue] = useState<number>(
    ruleDetails["spreadValue"] as number,
  );

  const updateDetails = (
    mc: string,
    mv: number,
    sc: string,
    sv: number,
  ): void => {
    updateRuleDetails({
      type: "Combination 1",
      moneylineEquality: mc,
      moneylineValue: mv,
      spreadEquality: sc,
      spreadValue: sv,
    });
  };

  // Save a moneyline value that was corrected out of the -100..+100 gap above.
  useEffect(() => {
    updateDetails(
      moneylineComparison,
      moneylineValue,
      spreadComparison,
      spreadValue,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ marginTop: 10, marginBottom: 10 }}>
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "flex-start",
            justifyContent: "center",
          }}
        >
          <span className="font_family_base" style={styles.inputText}>
            If the Moneyline is{" "}
          </span>
          <div style={{ paddingLeft: 5, paddingRight: 5, marginTop: 5 }}>
            <SelectDialog
              selectedValue={moneylineComparison}
              updateSelectedValue={(v) => {
                setMoneylineComparison(v);
                updateDetails(v, moneylineValue, spreadComparison, spreadValue);
              }}
              optionData={comparisons}
              width={60}
              marginTop={0}
            />
          </div>
          <StepperInput
            initialValue={moneylineValue}
            min={MONEYLINE_STEPPER.min}
            max={9999}
            step={MONEYLINE_STEPPER.step}
            bigStep={MONEYLINE_STEPPER.bigStep}
            gap={MONEYLINE_STEPPER.gap}
            onValueChange={(v) => {
              setMoneylineValue(v);
              updateDetails(
                moneylineComparison,
                v,
                spreadComparison,
                spreadValue,
              );
            }}
            skipZero={true}
            showDecimalValue={false}
            showPercent={false}
            useBigStep={true}
            ordinalMap={false}
            showPlusSign={true}
          />
          <span className="font_family_base" style={styles.inputText}>
            and{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            the{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            Spread{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            is{" "}
          </span>
          <div style={{ paddingLeft: 5, paddingRight: 5, marginTop: 5 }}>
            <SelectDialog
              selectedValue={spreadComparison}
              updateSelectedValue={(v) => {
                setSpreadComparison(v);
                updateDetails(
                  moneylineComparison,
                  moneylineValue,
                  v,
                  spreadValue,
                );
              }}
              optionData={comparisons}
              width={60}
              marginTop={0}
            />
          </div>
          <StepperInput
            initialValue={spreadValue}
            min={-9999}
            max={9999}
            step={0.5}
            bigStep={10.0}
            onValueChange={(v) => {
              setSpreadValue(v);
              updateDetails(
                moneylineComparison,
                moneylineValue,
                spreadComparison,
                v,
              );
            }}
            skipZero={false}
            showDecimalValue={true}
            showPercent={false}
            useBigStep={true}
            ordinalMap={false}
            showPlusSign={true}
          />
        </div>
      </div>
    </div>
  );
};

const Rule17Component_CombinationMoneylineOrSpreadValues: React.FC<
  OverUnderComponentProps
> = ({ ruleDetails, updateRuleDetails }) => {
  const comparisons = [
    { label: "Greater Than or Equal (>=)", value: ">=" },
    { label: "Less Than or Equal (<=)", value: "<=" },
  ];
  const [moneylineComparison, setMoneylineComparison] = useState<string>(
    ruleDetails["moneylineEquality"] as string,
  );
  const [moneylineValue, setMoneylineValue] = useState<number>(() =>
    initialHitsValue(ruleDetails["moneylineValue"], MONEYLINE_STEPPER),
  );
  const [spreadComparison, setSpreadComparison] = useState<string>(
    ruleDetails["spreadEquality"] as string,
  );
  const [spreadValue, setSpreadValue] = useState<number>(
    ruleDetails["spreadValue"] as number,
  );

  const updateDetails = (
    mc: string,
    mv: number,
    sc: string,
    sv: number,
  ): void => {
    updateRuleDetails({
      type: "Combination 2",
      moneylineEquality: mc,
      moneylineValue: mv,
      spreadEquality: sc,
      spreadValue: sv,
    });
  };

  // Save a moneyline value that was corrected out of the -100..+100 gap above.
  useEffect(() => {
    updateDetails(
      moneylineComparison,
      moneylineValue,
      spreadComparison,
      spreadValue,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ marginTop: 10, marginBottom: 10 }}>
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "flex-start",
            justifyContent: "center",
          }}
        >
          <span className="font_family_base" style={styles.inputText}>
            If the Moneyline is{" "}
          </span>
          <div style={{ paddingLeft: 5, paddingRight: 5, marginTop: 5 }}>
            <SelectDialog
              selectedValue={moneylineComparison}
              updateSelectedValue={(v) => {
                setMoneylineComparison(v);
                updateDetails(v, moneylineValue, spreadComparison, spreadValue);
              }}
              optionData={comparisons}
              width={60}
              marginTop={0}
            />
          </div>
          <StepperInput
            initialValue={moneylineValue}
            min={MONEYLINE_STEPPER.min}
            max={9999}
            step={MONEYLINE_STEPPER.step}
            bigStep={MONEYLINE_STEPPER.bigStep}
            gap={MONEYLINE_STEPPER.gap}
            onValueChange={(v) => {
              setMoneylineValue(v);
              updateDetails(
                moneylineComparison,
                v,
                spreadComparison,
                spreadValue,
              );
            }}
            skipZero={true}
            showDecimalValue={false}
            showPercent={false}
            useBigStep={true}
            ordinalMap={false}
            showPlusSign={true}
          />
          <span className="font_family_base" style={styles.inputText}>
            or{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            the{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            Spread{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            is{" "}
          </span>
          <div style={{ paddingLeft: 5, paddingRight: 5, marginTop: 5 }}>
            <SelectDialog
              selectedValue={spreadComparison}
              updateSelectedValue={(v) => {
                setSpreadComparison(v);
                updateDetails(
                  moneylineComparison,
                  moneylineValue,
                  v,
                  spreadValue,
                );
              }}
              optionData={comparisons}
              width={60}
              marginTop={0}
            />
          </div>
          <StepperInput
            initialValue={spreadValue}
            min={-9999}
            max={9999}
            step={0.5}
            bigStep={10.0}
            onValueChange={(v) => {
              setSpreadValue(v);
              updateDetails(
                moneylineComparison,
                moneylineValue,
                spreadComparison,
                v,
              );
            }}
            skipZero={false}
            showDecimalValue={true}
            showPercent={false}
            useBigStep={true}
            ordinalMap={false}
            showPlusSign={true}
          />
        </div>
      </div>
    </div>
  );
};

const Rule18Component_CombinationStartingSpreadAndMoneylineValues: React.FC<
  OverUnderComponentProps
> = ({ ruleDetails, updateRuleDetails }) => {
  const comparisons = [
    { label: "Greater Than or Equal (>=)", value: ">=" },
    { label: "Less Than or Equal (<=)", value: "<=" },
  ];
  const [moneylineComparison, setMoneylineComparison] = useState<string>(
    ruleDetails["moneylineEquality"] as string,
  );
  const [moneylineValue, setMoneylineValue] = useState<number>(() =>
    initialHitsValue(ruleDetails["moneylineValue"], MONEYLINE_STEPPER),
  );
  const [spreadComparison, setSpreadComparison] = useState<string>(
    ruleDetails["spreadEquality"] as string,
  );
  const [spreadValue, setSpreadValue] = useState<number>(
    ruleDetails["spreadValue"] as number,
  );

  const updateDetails = (
    mc: string,
    mv: number,
    sc: string,
    sv: number,
  ): void => {
    updateRuleDetails({
      type: "Combination 3",
      moneylineEquality: mc,
      moneylineValue: mv,
      spreadEquality: sc,
      spreadValue: sv,
    });
  };

  // Save a moneyline value that was corrected out of the -100..+100 gap above.
  useEffect(() => {
    updateDetails(
      moneylineComparison,
      moneylineValue,
      spreadComparison,
      spreadValue,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ marginTop: 10, marginBottom: 10 }}>
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "flex-start",
            justifyContent: "center",
          }}
        >
          <span className="font_family_base" style={styles.inputText}>
            If the Starting Spread is{" "}
          </span>
          <div style={{ paddingLeft: 5, paddingRight: 5, marginTop: 5 }}>
            <SelectDialog
              selectedValue={spreadComparison}
              updateSelectedValue={(v) => {
                setSpreadComparison(v);
                updateDetails(
                  moneylineComparison,
                  moneylineValue,
                  v,
                  spreadValue,
                );
              }}
              optionData={comparisons}
              width={60}
              marginTop={0}
            />
          </div>
          <StepperInput
            initialValue={spreadValue}
            min={-9999}
            max={9999}
            step={0.5}
            bigStep={10.0}
            onValueChange={(v) => {
              setSpreadValue(v);
              updateDetails(
                moneylineComparison,
                moneylineValue,
                spreadComparison,
                v,
              );
            }}
            skipZero={false}
            showDecimalValue={true}
            showPercent={false}
            useBigStep={true}
            ordinalMap={false}
            showPlusSign={true}
          />
          <span className="font_family_base" style={styles.inputText}>
            and{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            the{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            Moneyline{" "}
          </span>
          <span className="font_family_base" style={styles.inputText}>
            hits{" "}
          </span>
          <div style={{ paddingLeft: 5, paddingRight: 5, marginTop: 5 }}>
            <SelectDialog
              selectedValue={moneylineComparison}
              updateSelectedValue={(v) => {
                setMoneylineComparison(v);
                updateDetails(v, moneylineValue, spreadComparison, spreadValue);
              }}
              optionData={comparisons}
              width={60}
              marginTop={0}
            />
          </div>
          <StepperInput
            initialValue={moneylineValue}
            min={MONEYLINE_STEPPER.min}
            max={9999}
            step={MONEYLINE_STEPPER.step}
            bigStep={MONEYLINE_STEPPER.bigStep}
            gap={MONEYLINE_STEPPER.gap}
            onValueChange={(v) => {
              setMoneylineValue(v);
              updateDetails(
                moneylineComparison,
                v,
                spreadComparison,
                spreadValue,
              );
            }}
            skipZero={true}
            showDecimalValue={false}
            showPercent={false}
            useBigStep={true}
            ordinalMap={false}
            showPlusSign={true}
          />
        </div>
      </div>
    </div>
  );
};

// Main Rule Logic Component
const RuleLogicComponent: React.FC<RuleLogicComponentProps> = ({
  ruleType,
  gamePartName,
  gamePartCount,
  ruleDetails,
  updateRuleDetails,
}) => {
  // const getDefaultDetails = (type: string): RuleDetails => {
  //   return Object.keys(ruleDetails).length === 0
  //     ? ruleOptionsDict[type].defaults
  //     : ruleDetails;
  // };

  // "Over/Under 1Percent": "Percent Change Over the Game",
  // "Over/Under 3Shift": "O/U vs Initial O/U",
  // "Over/Under 3Detail": "Multi-select Total Score vs Initial O/U",
  // "Over/Under 3ShiftDetail": "Multi-select O/U vs Initial O/U",
  // "Spread 1": "Value Change Over the Game",
  // "Spread 1Percent": "Percent Change Over the Game",
  // "Spread 2": "Hits a Target Value",
  // "Moneyline 1": "Value Change Over the Game",
  // "Moneyline 1Percent": "Percent Change Over the Game",
  // "Moneyline 2": "Hits a Target Value",
  // "Combination 1": "Moneyline and Spread Hit Target Values",
  // "Combination 2": "Moneyline or Spread Hit Target Values",

  return (
    <div style={{ padding: 10 }}>
      {ruleType === "1" && (
        // <Rule1Component_OverUnderValueChange
        //   gamePartCount={gamePartCount}
        //   gamePartName={gamePartName}
        //   ruleDetails={ruleDetails}
        //   updateRuleDetails={updateRuleDetails}
        // />
        <GenericValueChange
          bigValues={false}
          ruleTargetName="Over/Under"
          gamePartCount={gamePartCount}
          gamePartName={gamePartName}
          ruleDetails={ruleDetails}
          updateRuleDetails={updateRuleDetails}
        />
      )}
      {ruleType === "2" && (
        <Rule2Component_OverUnderPercentChange
          gamePartCount={gamePartCount}
          gamePartName={gamePartName}
          ruleDetails={ruleDetails}
          updateRuleDetails={updateRuleDetails}
        />
      )}
      {ruleType === "3" && (
        <Rule3Component_OverUnderHitsValue
          gamePartCount={gamePartCount}
          gamePartName={gamePartName}
          ruleDetails={ruleDetails}
          updateRuleDetails={updateRuleDetails}
        />
      )}
      {ruleType === "4" && (
        <Rule4Component_TotalOverUnderPercentOfInitial
          gamePartCount={gamePartCount}
          gamePartName={gamePartName}
          ruleDetails={ruleDetails}
          updateRuleDetails={updateRuleDetails}
        />
      )}
      {ruleType === "5" && (
        <Rule5Component_OverUnderPercentOfInitial
          gamePartCount={gamePartCount}
          gamePartName={gamePartName}
          ruleDetails={ruleDetails}
          updateRuleDetails={updateRuleDetails}
        />
      )}
      {ruleType === "6" && (
        <Rule6Component_TotalOverUnderPercentOfInitialMultiSelect
          gamePartCount={gamePartCount}
          gamePartName={gamePartName}
          ruleDetails={ruleDetails}
          updateRuleDetails={updateRuleDetails}
        />
      )}
      {ruleType === "7" && (
        <Rule7Component_OverUnderPercentOfInitialMultiSelect
          gamePartCount={gamePartCount}
          gamePartName={gamePartName}
          ruleDetails={ruleDetails}
          updateRuleDetails={updateRuleDetails}
        />
      )}
      {ruleType === "9" && (
        <Rule9Component_ValueChange
          gamePartCount={gamePartCount}
          gamePartName={gamePartName}
          ruleDetails={ruleDetails}
          updateRuleDetails={updateRuleDetails}
        />
      )}
      {ruleType === "10" && (
        <Rule10Component_SpreadPercentChange
          gamePartCount={gamePartCount}
          gamePartName={gamePartName}
          ruleDetails={ruleDetails}
          updateRuleDetails={updateRuleDetails}
        />
      )}
      {ruleType === "11" && (
        <Rule11Component_SpreadHitsValue
          gamePartCount={gamePartCount}
          gamePartName={gamePartName}
          ruleDetails={ruleDetails}
          updateRuleDetails={updateRuleDetails}
        />
      )}
      {ruleType === "12" && (
        <Rule12Component_MoneylineValueChange
          gamePartCount={gamePartCount}
          gamePartName={gamePartName}
          ruleDetails={ruleDetails}
          updateRuleDetails={updateRuleDetails}
        />
      )}
      {ruleType === "13" && (
        <Rule13Component_1MoneylinePercentChange
          gamePartCount={gamePartCount}
          gamePartName={gamePartName}
          ruleDetails={ruleDetails}
          updateRuleDetails={updateRuleDetails}
        />
      )}
      {ruleType === "14" && (
        <Rule14Component_MoneylineHitsValue
          gamePartCount={gamePartCount}
          gamePartName={gamePartName}
          ruleDetails={ruleDetails}
          updateRuleDetails={updateRuleDetails}
        />
      )}
      {ruleType === "15" && (
        <Rule15Component_MoneylineStartingAndLiveValues
          gamePartCount={gamePartCount}
          gamePartName={gamePartName}
          ruleDetails={ruleDetails}
          updateRuleDetails={updateRuleDetails}
        />
      )}
      {ruleType === "16" && (
        <Rule16Component_CombinationMoneylineAndSpreadValues
          gamePartCount={gamePartCount}
          gamePartName={gamePartName}
          ruleDetails={ruleDetails}
          updateRuleDetails={updateRuleDetails}
        />
      )}
      {ruleType === "17" && (
        <Rule17Component_CombinationMoneylineOrSpreadValues
          gamePartCount={gamePartCount}
          gamePartName={gamePartName}
          ruleDetails={ruleDetails}
          updateRuleDetails={updateRuleDetails}
        />
      )}
      {ruleType === "18" && (
        <Rule18Component_CombinationStartingSpreadAndMoneylineValues
          gamePartCount={gamePartCount}
          gamePartName={gamePartName}
          ruleDetails={ruleDetails}
          updateRuleDetails={updateRuleDetails}
        />
      )}
    </div>
  );
};

const EqualityString = ({ type }: { type: string }) => {
  if (type === ">=") return "Greater Than or Equal to (>=)";
  if (type === "<=") return "Less Than or Equal to (<=)";
  return type;
};

const Rule1Display_OverUnderValueChange: React.FC<BaseDisplayProps> = ({
  ruleDetails,
}) => (
  <div style={{ marginTop: 10, marginBottom: 10 }}>
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "flex-start",
        justifyContent: "center",
      }}
    >
      <span className="font_family_base" style={styles.inputText}>
        When the Over/Under changes by{" "}
        {(ruleDetails["value_change"] as number) > 0 ? "+" : ""}
        {(ruleDetails["value_change"] as number).toFixed(1)} from the Start of
        the Game
      </span>
    </div>
  </div>
);

const Rule2Display_OverUnderPercentChange: React.FC<BaseDisplayProps> = ({
  ruleDetails,
}) => (
  <div style={{ marginTop: 10, marginBottom: 10 }}>
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "flex-start",
        justifyContent: "center",
      }}
    >
      <span className="font_family_base" style={styles.inputText}>
        When the Over/Under changes by{" "}
        {(ruleDetails["percent"] as number) > 0 ? "+" : ""}
        {(ruleDetails["percent"] as number).toFixed(0)}% from the Start of the
        Game
      </span>
    </div>
  </div>
);

const Rule3Display_OverUnderHitsValue: React.FC<BaseDisplayProps> = ({
  ruleDetails,
}) => (
  <div style={{ marginTop: 10, marginBottom: 10 }}>
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "flex-start",
        justifyContent: "center",
      }}
    >
      <span className="font_family_base" style={styles.inputText}>
        If the Over/Under is{" "}
        <EqualityString type={ruleDetails["equality"] as string} />{" "}
        {(ruleDetails["value"] as number).toFixed(1)}
      </span>
    </div>
  </div>
);

const Rule4Display_TotalOverUnderPercentOfInitial: React.FC<
  BaseDisplayProps
> = ({ gamePartName, ruleDetails }) => {
  const ordinal_names = [
    "0th",
    "1st",
    "2nd",
    "3rd",
    "4th",
    "5th",
    "6th",
    "7th",
    "8th",
    "9th",
  ];
  return (
    <div style={{ marginTop: 10, marginBottom: 10 }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          alignItems: "flex-start",
          justifyContent: "center",
        }}
      >
        <span className="font_family_base" style={styles.inputText}>
          At the Start of the {ordinal_names[ruleDetails["period"] as number]}{" "}
          {gamePartName}, the Total Score is{" "}
          <EqualityString type={ruleDetails["equality"] as string} />{" "}
          {ruleDetails["percent"] as string}% of the Over/Under at the Start of
          the Game
        </span>
      </div>
    </div>
  );
};

const Rule5Display_OverUnderPercentOfInitial: React.FC<BaseDisplayProps> = ({
  gamePartName,
  ruleDetails,
}) => {
  const ordinal_names = [
    "0th",
    "1st",
    "2nd",
    "3rd",
    "4th",
    "5th",
    "6th",
    "7th",
    "8th",
    "9th",
  ];
  return (
    <div style={{ marginTop: 10, marginBottom: 10 }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          alignItems: "flex-start",
          justifyContent: "center",
        }}
      >
        <span className="font_family_base" style={styles.inputText}>
          At the Start of the {ordinal_names[ruleDetails["period"] as number]}{" "}
          {gamePartName}, the Over/Under is{" "}
          <EqualityString type={ruleDetails["equality"] as string} />{" "}
          {ruleDetails["percent"] as string}% of the Over/Under at the Start of
          the Game
        </span>
      </div>
    </div>
  );
};

const Rule6Display_TotalOverUnderPercentOfInitialMultiSelect: React.FC<
  BaseDisplayProps
> = ({ gamePartName, ruleDetails }) => {
  const ordinalNames = [
    "0th",
    "1st",
    "2nd",
    "3rd",
    "4th",
    "5th",
    "6th",
    "7th",
    "8th",
    "9th",
    "10th",
    "11th",
    "12th",
  ];
  type PeriodConfig = { equality: string; percent: number; enabled?: boolean };
  const periods = (ruleDetails["periods"] ?? {}) as Record<
    string,
    PeriodConfig
  >;

  return (
    <div style={{ marginTop: 10, marginBottom: 10 }}>
      {Object.entries(periods)
        .sort(([a], [b]) => Number(a) - Number(b))
        .filter(([, cfg]) => cfg.enabled !== false)
        .map(([p, cfg]) => (
          <div
            key={p}
            style={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              alignItems: "flex-start",
              justifyContent: "center",
              marginBottom: 4,
            }}
          >
            <span className="font_family_base" style={styles.inputText}>
              {ordinalNames[Number(p)] ?? `${p}th`} {gamePartName}: Total Score
              is <EqualityString type={cfg.equality} /> {cfg.percent}% of O/U at
              Start of Game
            </span>
          </div>
        ))}
    </div>
  );
};

const Rule7Display_OverUnderPercentOfInitialMultiSelect: React.FC<
  BaseDisplayProps
> = ({ gamePartName, ruleDetails }) => {
  const ordinalNames = [
    "0th",
    "1st",
    "2nd",
    "3rd",
    "4th",
    "5th",
    "6th",
    "7th",
    "8th",
    "9th",
    "10th",
    "11th",
    "12th",
  ];
  type PeriodConfig = { equality: string; percent: number; enabled?: boolean };
  const periods = (ruleDetails["periods"] ?? {}) as Record<
    string,
    PeriodConfig
  >;

  return (
    <div style={{ marginTop: 10, marginBottom: 10 }}>
      {Object.entries(periods)
        .sort(([a], [b]) => Number(a) - Number(b))
        .filter(([, cfg]) => cfg.enabled !== false)
        .map(([p, cfg]) => (
          <div
            key={p}
            style={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              alignItems: "flex-start",
              justifyContent: "center",
              marginBottom: 4,
            }}
          >
            <span className="font_family_base" style={styles.inputText}>
              {ordinalNames[Number(p)] ?? `${p}th`} {gamePartName}: Ove/Under is{" "}
              <EqualityString type={cfg.equality} /> {cfg.percent}% of
              Over/Under at Start of Game
            </span>
          </div>
        ))}
    </div>
  );
};

const Rule9Display_SpreadValueChange: React.FC<BaseDisplayProps> = ({
  ruleDetails,
}) => (
  <div style={{ marginTop: 10, marginBottom: 10 }}>
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "flex-start",
        justifyContent: "center",
      }}
    >
      <span className="font_family_base" style={styles.inputText}>
        When the Spread changes by{" "}
        {(ruleDetails["value_change"] as number) > 0 ? "+" : ""}
        {(ruleDetails["value_change"] as number).toFixed(1)} from the Start of
        the Game
      </span>
    </div>
  </div>
);

const Rule10Display_SpreadPercentChange: React.FC<BaseDisplayProps> = ({
  ruleDetails,
}) => (
  <div style={{ marginTop: 10, marginBottom: 10 }}>
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "flex-start",
        justifyContent: "center",
      }}
    >
      <span className="font_family_base" style={styles.inputText}>
        When the Spread changes by{" "}
        {(ruleDetails["percent"] as number) > 0 ? "+" : ""}
        {(ruleDetails["percent"] as number).toFixed(0)}% from the Start of the
        Game
      </span>
    </div>
  </div>
);

const Rule11Display_SpreadHitsValue: React.FC<BaseDisplayProps> = ({
  ruleDetails,
}) => (
  <div style={{ marginTop: 10, marginBottom: 10 }}>
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "flex-start",
        justifyContent: "center",
      }}
    >
      <span className="font_family_base" style={styles.inputText}>
        If the Spread for {ruleDetails["team"] as string} is{" "}
        <EqualityString type={ruleDetails["equality"] as string} />{" "}
        {(ruleDetails["value"] as number) > 0 ? "+" : ""}
        {(ruleDetails["value"] as number).toFixed(1)}
      </span>
    </div>
  </div>
);

const Rule12Display_MoneylineValueChange: React.FC<BaseDisplayProps> = ({
  ruleDetails,
}) => (
  <div style={{ marginTop: 10, marginBottom: 10 }}>
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "flex-start",
        justifyContent: "center",
      }}
    >
      <span className="font_family_base" style={styles.inputText}>
        When the Moneyline changes by{" "}
        {(ruleDetails["value_change"] as number) > 0 ? "+" : ""}
        {(ruleDetails["value_change"] as number).toFixed(0)} from the Start of
        the Game
      </span>
    </div>
  </div>
);

const Rule13Display_MoneylinePercentChange: React.FC<BaseDisplayProps> = ({
  ruleDetails,
}) => (
  <div style={{ marginTop: 10, marginBottom: 10 }}>
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "flex-start",
        justifyContent: "center",
      }}
    >
      <span className="font_family_base" style={styles.inputText}>
        When the Moneyline changes by{" "}
        {(ruleDetails["percent"] as number) > 0 ? "+" : ""}
        {(ruleDetails["percent"] as number).toFixed(0)}% from the Start of the
        Game
      </span>
    </div>
  </div>
);

const Rule14Display_MoneylineHitsValue: React.FC<BaseDisplayProps> = ({
  ruleDetails,
}) => (
  <div style={{ marginTop: 10, marginBottom: 10 }}>
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "flex-start",
        justifyContent: "center",
      }}
    >
      <span className="font_family_base" style={styles.inputText}>
        If <EqualityString type={ruleDetails["team"] as string} /> Moneyline is{" "}
        <EqualityString type={ruleDetails["equality"] as string} />{" "}
        {(ruleDetails["value"] as number) > 0 ? "+" : ""}
        {(ruleDetails["value"] as number).toFixed(0)}
      </span>
    </div>
  </div>
);

const Rule15Display_MoneylineStartingAndLiveValues: React.FC<
  BaseDisplayProps
> = ({ ruleDetails }) => (
  <div style={{ marginTop: 10, marginBottom: 10 }}>
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "flex-start",
        justifyContent: "center",
      }}
    >
      <span className="font_family_base" style={styles.inputText}>
        If the starting Moneyline is{" "}
        <EqualityString type={ruleDetails["starting_equality"] as string} />{" "}
        {(ruleDetails["starting_value"] as number) > 0 ? "+" : ""}
        {(ruleDetails["starting_value"] as number).toFixed(0)} and the live
        Moneyline is{" "}
        <EqualityString type={ruleDetails["live_equality"] as string} />{" "}
        {(ruleDetails["live_value"] as number) > 0 ? "+" : ""}
        {(ruleDetails["live_value"] as number).toFixed(0)}
      </span>
    </div>
  </div>
);

const Rule16Display_CombinationMoneylineAndSpreadValues: React.FC<
  BaseDisplayProps
> = ({ ruleDetails }) => (
  <div style={{ marginTop: 10, marginBottom: 10 }}>
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "flex-start",
        justifyContent: "center",
      }}
    >
      <span className="font_family_base" style={styles.inputText}>
        If the Moneyline is{" "}
        <EqualityString type={ruleDetails["moneylineEquality"] as string} />{" "}
        {(ruleDetails["moneylineValue"] as number) > 0 ? "+" : ""}
        {ruleDetails["moneylineValue"] as number}
        {", "}
        and the Spread is{" "}
        <EqualityString type={ruleDetails["spreadEquality"] as string} />{" "}
        {(ruleDetails["spreadValue"] as number) > 0 ? "+" : ""}
        {(ruleDetails["spreadValue"] as number).toFixed(1)}
      </span>
    </div>
  </div>
);

const Rule17Display_CombinationMoneylineOrSpreadValues: React.FC<
  BaseDisplayProps
> = ({ ruleDetails }) => (
  <div style={{ marginTop: 10, marginBottom: 10 }}>
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "flex-start",
        justifyContent: "center",
      }}
    >
      <span className="font_family_base" style={styles.inputText}>
        If the Moneyline is{" "}
        <EqualityString type={ruleDetails["moneylineEquality"] as string} />{" "}
        {(ruleDetails["moneylineValue"] as number) > 0 ? "+" : ""}
        {ruleDetails["moneylineValue"] as number}
        {", "}
        or the Spread is{" "}
        <EqualityString type={ruleDetails["spreadEquality"] as string} />{" "}
        {(ruleDetails["spreadValue"] as number) > 0 ? "+" : ""}
        {(ruleDetails["spreadValue"] as number).toFixed(1)}
      </span>
    </div>
  </div>
);

const Rule18Display_CombinationStartingSpreadAndMoneylineValues: React.FC<
  BaseDisplayProps
> = ({ ruleDetails }) => (
  <div style={{ marginTop: 10, marginBottom: 10 }}>
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "flex-start",
        justifyContent: "center",
      }}
    >
      <span className="font_family_base" style={styles.inputText}>
        If the Starting Spread is{" "}
        <EqualityString type={ruleDetails["spreadEquality"] as string} />{" "}
        {(ruleDetails["spreadValue"] as number) > 0 ? "+" : ""}
        {(ruleDetails["spreadValue"] as number).toFixed(1)} and the Moneyline
        hits{" "}
        <EqualityString type={ruleDetails["moneylineEquality"] as string} />{" "}
        {(ruleDetails["moneylineValue"] as number) > 0 ? "+" : ""}
        {(ruleDetails["moneylineValue"] as number).toFixed(0)}
      </span>
    </div>
  </div>
);

const RuleLogicDisplay: React.FC<RuleLogicDisplayProps> = ({
  ruleType,
  gamePartName,
  gamePartCount,
  ruleDetails,
  textColor,
}) => (
  <div
    style={{
      padding: 10,
      ...(textColor ? { ["--rl-text-color" as string]: textColor } : {}),
    }}
  >
    {ruleType === "1" && (
      <Rule1Display_OverUnderValueChange
        gamePartCount={gamePartCount}
        gamePartName={gamePartName}
        ruleDetails={ruleDetails}
      />
    )}
    {ruleType === "2" && (
      <Rule2Display_OverUnderPercentChange
        gamePartCount={gamePartCount}
        gamePartName={gamePartName}
        ruleDetails={ruleDetails}
      />
    )}
    {ruleType === "3" && (
      <Rule3Display_OverUnderHitsValue
        gamePartCount={gamePartCount}
        gamePartName={gamePartName}
        ruleDetails={ruleDetails}
      />
    )}
    {ruleType === "4" && (
      <Rule4Display_TotalOverUnderPercentOfInitial
        gamePartCount={gamePartCount}
        gamePartName={gamePartName}
        ruleDetails={ruleDetails}
      />
    )}
    {ruleType === "5" && (
      <Rule5Display_OverUnderPercentOfInitial
        gamePartCount={gamePartCount}
        gamePartName={gamePartName}
        ruleDetails={ruleDetails}
      />
    )}
    {ruleType === "6" && (
      <Rule6Display_TotalOverUnderPercentOfInitialMultiSelect
        gamePartCount={gamePartCount}
        gamePartName={gamePartName}
        ruleDetails={ruleDetails}
      />
    )}
    {ruleType === "7" && (
      <Rule7Display_OverUnderPercentOfInitialMultiSelect
        gamePartCount={gamePartCount}
        gamePartName={gamePartName}
        ruleDetails={ruleDetails}
      />
    )}
    {ruleType === "9" && (
      <Rule9Display_SpreadValueChange
        gamePartCount={gamePartCount}
        gamePartName={gamePartName}
        ruleDetails={ruleDetails}
      />
    )}
    {ruleType === "10" && (
      <Rule10Display_SpreadPercentChange
        gamePartCount={gamePartCount}
        gamePartName={gamePartName}
        ruleDetails={ruleDetails}
      />
    )}
    {ruleType === "11" && (
      <Rule11Display_SpreadHitsValue
        gamePartCount={gamePartCount}
        gamePartName={gamePartName}
        ruleDetails={ruleDetails}
      />
    )}
    {ruleType === "12" && (
      <Rule12Display_MoneylineValueChange
        gamePartCount={gamePartCount}
        gamePartName={gamePartName}
        ruleDetails={ruleDetails}
      />
    )}
    {ruleType === "13" && (
      <Rule13Display_MoneylinePercentChange
        gamePartCount={gamePartCount}
        gamePartName={gamePartName}
        ruleDetails={ruleDetails}
      />
    )}
    {ruleType === "14" && (
      <Rule14Display_MoneylineHitsValue
        gamePartCount={gamePartCount}
        gamePartName={gamePartName}
        ruleDetails={ruleDetails}
      />
    )}
    {ruleType === "15" && (
      <Rule15Display_MoneylineStartingAndLiveValues
        gamePartCount={gamePartCount}
        gamePartName={gamePartName}
        ruleDetails={ruleDetails}
      />
    )}
    {ruleType === "16" && (
      <Rule16Display_CombinationMoneylineAndSpreadValues
        gamePartCount={gamePartCount}
        gamePartName={gamePartName}
        ruleDetails={ruleDetails}
      />
    )}
    {ruleType === "17" && (
      <Rule17Display_CombinationMoneylineOrSpreadValues
        gamePartCount={gamePartCount}
        gamePartName={gamePartName}
        ruleDetails={ruleDetails}
      />
    )}
    {ruleType === "18" && (
      <Rule18Display_CombinationStartingSpreadAndMoneylineValues
        gamePartCount={gamePartCount}
        gamePartName={gamePartName}
        ruleDetails={ruleDetails}
      />
    )}
  </div>
);

export default RuleLogicComponent;
export {
  RuleLogicDisplay,
  StepperInput,
  GenericValueChange,
  GenericPercentChange,
  GenericHitsValue,
  GenericTeamValueChange,
  GenericTeamPercentChange,
  GenericTeamHitsValue,
};

//Alert me when the live {name} changes by a specific amount from the opening value.\n\nAn NBA game opens with an O/U of 220. If the live O/U rises to 220.5 or higher (+0.5 points), alert me.
//Alert me when the live {name} changes by a specific amount from the opening value.\n\nA team opens as a -6.5 favorite. If the live spread moves to -7.0 or greater (+0.5 points)
//Alert me when the live {name} changes by a specific amount from the opening value.\n\nA team opens at +120. If the live moneyline inceases to +130 (+10 points) or higher, alert me.
